// @ts-nocheck
import React, {useEffect, useMemo, useState} from 'react'
import {useNavigate, Link} from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/he'
import AffiliateShell from './components/AffiliateShell'
import AffiliateMeetingModal from './components/AffiliateMeetingModal'
import {AFF, card} from './components/affiliateTheme'
import QRCode from 'react-qr-code'
import {getAgentStats, grabLeads, getLeads, editLead, addLeadComment, convertLead, getWaTemplates, sendWhatsappToLead, sendWhatsapp, getAgentListings, findLeadRealPhone, loginAsCustomer, sendWelcomeMessage, getWelcomePreview, waWebUrl, editCustomer, getCustomerProfiles, getCustomerProfilePreviewLink, startCustomerProfileLogin, getCustomerProfileQr, getCustomerProfileAuthApproval, resetCustomerProfileBarcode, sendProfileLoginLink, sendProfileLoginSms, bulkSendLoginLinks, syncAgentPosts, getAgents, claimAgentLead, getPbxConfig, setPbxExtension, pbxDial, getPbxStatus, getPbxRowCalls, getPbxCallsForRow, getPbxCall, pbxRecordingUrl, getPbxMissed, markPbxMissedHandled, inAffiliateApp, getPbxSoftphone} from './core/_requests'

const STATUSES = [
  {id: 'new', label: 'חדש', cls: 'badge-light-danger'},
  {id: 'no_answer', label: 'אין מענה', cls: 'badge-light-info'},
  {id: 'contacted', label: 'יצרתי קשר', cls: 'badge-light-primary'},
  {id: 'follow_up', label: 'במעקב', cls: 'badge-light-warning'},
  {id: 'not_interested', label: 'לא מעוניין', cls: 'badge-light-dark'},
  {id: 'our_customer', label: 'לקוח שלנו', cls: 'badge-light-success'},
  {id: 'converted', label: 'הומר ללקוח', cls: 'badge-light-success'},
]
const statusMeta = (s) => STATUSES.find((x) => x.id === s) || STATUSES[0]
// A lead only counts as "converted" if a real account was created. A stale
// "converted" label with no account is treated as a normal (uncontacted) lead.
// Sales PBX: AI outcome of a call -> badge.
const CALL_OUTCOME = {
  interested: {label: 'מעוניין', cls: 'badge-light-success'},
  callback: {label: 'לחזור אליו', cls: 'badge-light-warning'},
  not_interested: {label: 'לא מעוניין', cls: 'badge-light-dark'},
  irrelevant: {label: 'לא רלוונטי', cls: 'badge-light-dark'},
  no_conversation: {label: 'לא הייתה שיחה', cls: 'badge-light-info'},
}
const DIAL_STATE = {
  dialing: 'מחייג ללקוח… כשיענה, השלוחה שלך תצלצל',
  answered: 'הלקוח ענה — הרם את הטלפון בשלוחה',
  connected: 'בשיחה',
  no_answer: 'הלקוח לא ענה',
  busy: 'הקו של הלקוח תפוס',
  failed: 'החיוג נכשל',
}
// "0501234567" form, to compare with the server's blocked_phones.
const localIl = (raw) => {
  let d = String(raw || '').replace(/[^\d]/g, '')
  if (d.startsWith('972')) d = '0' + d.slice(3)
  if (d && !d.startsWith('0')) d = '0' + d
  return d
}
const isBlockedNum = (l, raw) => (l.blocked_phones || []).includes(localIl(raw))
const BlockedTag = () => (
  <span className='badge badge-danger' style={{marginInlineStart: 6, fontWeight: 700, verticalAlign: 'middle'}} title='המספר שייך ללקוח פעיל של fbzipper שלא הגיע דרכך — אסור להתקשר'>
    <i className='bi bi-slash-circle me-1' style={{color: '#fff'}} />לקוח פעיל · אין להתקשר
  </span>
)
// <input type="datetime-local"> value for a date (local time), and back.
const toLocalInput = (d) => {
  const x = new Date(d)
  if (isNaN(x.getTime())) return ''
  const p = (n) => String(n).padStart(2, '0')
  return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())}T${p(x.getHours())}:${p(x.getMinutes())}`
}
const fuWhen = (d) => moment(d).calendar(null, {sameDay: '[היום] HH:mm', nextDay: '[מחר] HH:mm', nextWeek: 'dddd HH:mm', lastDay: '[אתמול] HH:mm', lastWeek: 'DD/MM HH:mm', sameElse: 'DD/MM HH:mm'})
// Separate date + time boxes instead of <input type="datetime-local">: that one
// reports an empty value until BOTH parts are filled, so picking only a date
// (e.g. today) silently saved nothing. Time defaults when only a date is picked.
const nextFullHour = () => { const d = new Date(); d.setHours(d.getHours() + 1, 0, 0, 0); return d }
const defaultTimeFor = (date) => {
  const p = (n) => String(n).padStart(2, '0')
  if (date === toLocalInput(new Date()).slice(0, 10)) { const d = nextFullHour(); return d.getDate() === new Date().getDate() ? `${p(d.getHours())}:00` : '23:30' }
  return '10:00'
}
const FollowUpPicker = ({value, onChange}: {value: string; onChange: (v: string) => void}) => {
  const [date, time] = value ? value.split('T') : ['', '']
  return (
    <div style={{display: 'flex', gap: 6}}>
      <input type='date' className='form-control' value={date || ''} onChange={(e) => {
        const d = e.target.value
        onChange(d ? `${d}T${time || defaultTimeFor(d)}` : '')
      }} />
      <input type='time' className='form-control' style={{maxWidth: 130}} value={time || ''} onChange={(e) => {
        const t = e.target.value
        const d = date || toLocalInput(new Date()).slice(0, 10)
        onChange(t ? `${d}T${t}` : date ? `${d}T${defaultTimeFor(d)}` : '')
      }} />
    </div>
  )
}
// Local "YYYY-MM-DDTHH:mm" -> ISO (UTC). Sending the bare local string lets the
// server (UTC clock) read it 2-3h off, pushing a late "today" into tomorrow.
const localToIso = (v) => { if (!v) return null; const d = new Date(v); return isNaN(d.getTime()) ? null : d.toISOString() }
const digitsOf = (p) => { let d = String(p || '').replace(/\D/g, ''); if (d.startsWith('972')) d = '0' + d.slice(3); return d }
const tomorrowAt = (h) => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(h, 0, 0, 0); return d }
const fmtSecs = (s) => (s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : '')

const effStatusOf = (l) => (l.converted_account ? 'converted' : (l.status === 'converted' ? 'new' : (l.status || 'new')))

// FB's QR login is off (see admin settings → התחברות פרופילים), so a client gets
// a /c/:code link and types their FB email + password there. Which link + which
// wording is a server decision — every profile carries login_method + login_url.
//
// "תחילת הפרסום", not "חידוש הפרסום": an affiliate's customers are brand new and
// have never advertised with us, so the admin re-login wording (which is aimed at
// existing customers whose profile dropped) is wrong here.
const connectMsg = (url: string) =>
  `לחיבור הפרופיל ותחילת הפרסום היכנסו לקישור והזינו את המייל והסיסמה של הפייסבוק:\n${url}\nצוות FBZipper`

// Small phone button next to a number: click-to-call through the PBX.
const CallBtn = ({onClick, busy}) => (
  <button
    className='btn btn-icon btn-sm btn-light-primary'
    style={{width: 26, height: 26, marginInlineStart: 6, verticalAlign: 'middle'}}
    onClick={onClick}
    disabled={busy}
    title='התקשר — המערכת תחייג ללקוח ותצלצל לשלוחה שלך כשיענה'
  >
    {busy ? <span className='spinner-border spinner-border-sm' style={{width: 12, height: 12}} /> : <i className='bi bi-telephone-fill' style={{fontSize: 12}} />}
  </button>
)

const AffiliateLeadsMgrWrapper = () => {
  moment.locale('he')
  const navigate = useNavigate()
  const [stats, setStats] = useState<any>(null)
  const [leads, setLeads] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [grabbing, setGrabbing] = useState(false)
  const [filter, setFilter] = useState('all')
  const [search, setSearch] = useState('')
  const [showNotInterested, setShowNotInterested] = useState(false)
  const [editRow, setEditRow] = useState<any>(null)
  const [note, setNote] = useState('')

  // Customer the meeting-booking modal is open for ({_id, name}), or null.
  const [meetingFor, setMeetingFor] = useState<any>(null)

  // Converted-customer actions (merged from the old customers page)
  const [welcomeSending, setWelcomeSending] = useState<string | null>(null)
  const [welcomeFor, setWelcomeFor] = useState<any | null>(null) // lead whose channel picker is open
  const [welcomePreview, setWelcomePreview] = useState<{message: string; phone: string} | null>(null)
  const [welcomeCopied, setWelcomeCopied] = useState(false)
  const [syncingLead, setSyncingLead] = useState<string | null>(null)

  // Re-sync a converted customer's yad2 posts from the agent's current listings.
  const syncLeadPosts = async (l) => {
    const phone = l.display_phone || l.phone
    if (!l.customer || !phone) return
    if (!window.confirm(`לסנכרן את הפוסטים של ${l.name || ''} מיד2?\nיעודכנו מחירים, יתווספו נכסים חדשים, ויוסרו נכסים שנמכרו/ירדו.`)) return
    setSyncingLead(l._id)
    try {
      const res = await syncAgentPosts({
        customerId: l.customer._id, phone,
        licenseText: l.license_number ? `רישיון תיווך: ${l.license_number}` : undefined,
        agentName: l.name || undefined, agencyName: l.agency_name || undefined,
        autoDaily: true,
      })
      if (res.data?.success) {
        alert(`סנכרון הושלם ✓\nעודכנו ${res.data.updated}, נוספו ${(res.data as any).added}, הוסרו ${(res.data as any).removed || 0}.\n🔄 סנכרון יומי אוטומטי הופעל.`)
      } else {
        alert(res.data?.error || 'הסנכרון נכשל')
      }
    } catch (e: any) {
      alert('הסנכרון נכשל: ' + (e?.response?.data?.error || e?.message))
    }
    setSyncingLead(null)
  }
  const [custEdit, setCustEdit] = useState<any>(null) // {lead, form}
  const [custSaving, setCustSaving] = useState(false)

  const openCustEdit = (l) => {
    const c = l.customer || {}
    setCustEdit({lead: l, form: {first_name: c.first_name || '', last_name: c.last_name || '', phone: c.phone || '', email: c.email || '', company_name: c.company_name || ''}})
  }
  const saveCustEdit = async () => {
    if (!custEdit) return
    setCustSaving(true)
    try {
      const res = await editCustomer(custEdit.lead.customer._id, custEdit.form)
      if (res.data?.success) {
        const upd = res.data.customer
        setLeads((prev) => prev.map((x) => (x._id === custEdit.lead._id ? {...x, name: `${upd.first_name || ''} ${upd.last_name || ''}`.trim() || x.name, phone: upd.phone, display_phone: x.is_manual ? upd.phone : x.display_phone, agency_name: x.is_manual ? upd.company_name : x.agency_name, customer: {...x.customer, ...upd}} : x)))
        setCustEdit(null)
      } else {
        alert(res.data?.error || 'שמירה נכשלה')
      }
    } catch (e: any) {
      alert('שמירה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
    setCustSaving(false)
  }
  const [profCustomer, setProfCustomer] = useState<any>(null) // {lead, customer}
  const [profiles, setProfiles] = useState<any[]>([])
  const [profLoading, setProfLoading] = useState(false)
  const [connecting, setConnecting] = useState<any>(null) // {profileId, status, url, code}
  // The post-scan device-verification confirmation ({profileId, code, url}) —
  // the 2-digit number FB asks the customer to tap on their phone to finish.
  const [authApproval, setAuthApproval] = useState<any>(null)
  const authRef = React.useRef<any>(null)
  // Customer id we've already auto-started the QR for, so opening the modal kicks
  // off the barcode once (the first time) without re-triggering on every render.
  const autoStartedRef = React.useRef<string | null>(null)
  const [profPhones, setProfPhones] = useState<Record<string, string>>({})
  const [linkSentFor, setLinkSentFor] = useState<Record<string, boolean>>({})
  const [bulkSending, setBulkSending] = useState(false)
  const [copied, setCopied] = useState(false)
  const [resetting, setResetting] = useState(false)
  // Live-browser link per profile (profileId -> url), so the affiliate can do
  // the FB login FOR the client. previewBusy holds the profile being minted.
  const [previewLinks, setPreviewLinks] = useState<Record<string, string>>({})
  const [previewBusy, setPreviewBusy] = useState<string | null>(null)
  const [nowTs, setNowTs] = useState(() => Date.now()) // ticks every 1s while a barcode is pending (drives the reset countdown)
  const pollRef = React.useRef<any>(null)
  const RESET_AFTER_SEC = 60 // only allow delete+recreate after the barcode has failed to show for this long

  const handleLoginAs = async (customerId) => {
    try {
      const res = await loginAsCustomer(customerId)
      if (!res.data?.api_token) return
      const affiliateAuth = localStorage.getItem('kt-auth-react-v')
      const w = window.open('about:blank', '_blank')
      if (!w) return
      w.localStorage.setItem('kt-auth-react-v', JSON.stringify({api_token: res.data.api_token}))
      if (affiliateAuth) w.localStorage.setItem('affiliate_return', JSON.stringify({auth: affiliateAuth}))
      w.location.href = '/campaigns'
    } catch (e: any) {
      alert('שגיאה בכניסה כלקוח: ' + (e?.response?.data?.error || e?.message))
    }
  }

  // Open the WhatsApp/SMS channel picker. The picker itself is the confirmation
  // (it warns when already sent), so re-sends always get the channel choice too.
  const openWelcomePicker = (l) => {
    if (!l.customer) return
    setWelcomeFor(l)
    setWelcomePreview(null)
    setWelcomeCopied(false)
    // Fetch the message text so it can be shown (copy) + used for the wa.me link.
    getWelcomePreview(l.customer._id)
      .then((res) => { if (res.data?.success && res.data.message) setWelcomePreview({message: res.data.message, phone: res.data.phone || ''}) })
      .catch(() => {})
  }

  // Manual fallback: open WhatsApp Web/app with the welcome message prefilled, so
  // the affiliate can send it themselves if the server-side WhatsApp send fails.
  const welcomeViaWaWeb = (l) => {
    if (!welcomePreview) return
    window.open(waWebUrl(welcomePreview.phone, welcomePreview.message), '_blank')
    setLeads((prev) => prev.map((x) => (x._id === l._id ? {...x, customer: {...x.customer, welcome_sent: true, welcome_sent_at: new Date().toISOString()}} : x)))
    setWelcomeFor(null)
  }

  const sendWelcome = async (l, channel: 'whatsapp' | 'sms') => {
    const c = l.customer
    if (!c) return
    setWelcomeFor(null)
    setWelcomeSending(c._id)
    try {
      const res = await sendWelcomeMessage(c._id, channel)
      if (res.data?.success) {
        setLeads((prev) => prev.map((x) => (x._id === l._id ? {...x, customer: {...x.customer, welcome_sent: true, welcome_sent_at: res.data.welcome_sent_at}} : x)))
      } else alert(res.data?.error || 'שליחה נכשלה')
    } catch (e: any) {
      alert('שליחה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
    setWelcomeSending(null)
  }

  // ---- FB profile connection (for converted leads) ----
  const openProfiles = async (l) => {
    setProfCustomer(l)
    setProfiles([]); setConnecting(null); setLinkSentFor({}); setPreviewLinks({}); setPreviewBusy(null); setProfLoading(true)
    try {
      const res = await getCustomerProfiles(l.customer._id)
      const list = res.data || []
      setProfiles(list)
      const phones: Record<string, string> = {}
      list.forEach((p: any) => (phones[p._id] = p.login_link_phone || (l.real_phones?.[0]?.display_phone) || ''))
      setProfPhones(phones)
    } catch (e: any) {
      alert('שגיאה בטעינת פרופילים: ' + (e?.response?.data?.error || e?.message))
    }
    setProfLoading(false)
  }
  const closeProfiles = () => {
    if (pollRef.current) clearInterval(pollRef.current)
    pollRef.current = null
    if (authRef.current) clearInterval(authRef.current)
    authRef.current = null
    autoStartedRef.current = null
    setProfCustomer(null); setConnecting(null); setAuthApproval(null)
  }
  const sendLink = async (p) => {
    const ph = (profPhones[p._id] || '').trim()
    if (!ph) return alert('הזן מספר טלפון')
    try {
      await sendProfileLoginLink(profCustomer.customer._id, p._id, ph)
      setLinkSentFor((m) => ({...m, [p._id]: true}))
    } catch (e: any) {
      alert('שליחה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
  }
  const sendSmsLink = async (p) => {
    const ph = (profPhones[p._id] || '').trim()
    if (!ph) return alert('הזן מספר טלפון')
    try {
      await sendProfileLoginSms(profCustomer.customer._id, p._id, ph)
      setLinkSentFor((m) => ({...m, [p._id]: true}))
      alert('SMS נשלח ✓')
    } catch (e: any) {
      const err = e?.response?.data?.error
      alert(err === 'sms_not_configured' ? 'שירות ה‑SMS אינו מוגדר' : 'שליחת SMS נכשלה: ' + (err || e?.message))
    }
  }
  const bulkSendLinks = async () => {
    const items = profiles.filter((p) => !p.connected && (profPhones[p._id] || '').trim()).map((p) => ({profileId: p._id, phone: (profPhones[p._id] || '').trim()}))
    if (!items.length) return alert('אין פרופילים עם מספר טלפון לשליחה')
    if (!window.confirm(`לשלוח קישור התחברות ל-${items.length} פרופילים?`)) return
    setBulkSending(true)
    try {
      const res = await bulkSendLoginLinks(profCustomer.customer._id, items)
      const marked: Record<string, boolean> = {}
      items.forEach((it) => (marked[it.profileId] = true))
      setLinkSentFor((m) => ({...m, ...marked}))
      alert(`נשלחו ${res.data?.sent} קישורים${res.data?.failed?.length ? `, נכשלו ${res.data.failed.length}` : ''} ✓`)
    } catch (e: any) {
      alert('שליחה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
    setBulkSending(false)
  }
  // Open this profile's real browser and let the affiliate finish the Facebook
  // login themselves — the same live preview the client's link would have given
  // them, minus any dashboard access.
  //
  // The tab is opened SYNCHRONOUSLY from the click with the link the profile
  // list already carries: open it after an await and the browser treats it as an
  // unrequested popup and blocks it. The request that follows is only there to
  // make sure a browser is actually running for this profile — the preview page
  // will pick it up as it comes online.
  const openLiveLogin = async (p) => {
    if (!profCustomer) return
    const url = previewLinks[p._id] || p.preview_url
    if (url) window.open(url, '_blank')
    if (previewBusy) return
    setPreviewBusy(p._id)
    try {
      const res = await getCustomerProfilePreviewLink(profCustomer.customer._id, p._id)
      if (res.data?.url) {
        setPreviewLinks((m) => ({...m, [p._id]: res.data.url}))
        // Only nothing was opened above (an old cached list with no preview_url)
        // does this need its own window — otherwise the tab is already up.
        if (!url) window.open(res.data.url, '_blank')
      }
    } catch (e: any) {
      if (!url) alert('פתיחת מסך ההתחברות נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
    setPreviewBusy(null)
  }
  const connectProfile = async (profile) => {
    if (!profCustomer) return
    // Password mode: the link is minted with the profile list — nothing to poll for.
    if (profile.login_method === 'password') {
      if (profile.login_url) window.open(profile.login_url, '_blank')
      return
    }
    setConnecting({profileId: profile._id, status: 'pending', url: '', code: null, startedAt: Date.now()})
    setAuthApproval(null)
    try { await startCustomerProfileLogin(profCustomer.customer._id, profile._id) } catch (_) {}
    if (pollRef.current) clearInterval(pollRef.current)
    let tries = 0
    let authPollStarted = false
    pollRef.current = setInterval(async () => {
      tries++
      try {
        const res = await getCustomerProfileQr(profCustomer.customer._id, profile._id)
        if (res.data?.status === 'ready' && res.data?.url) {
          // KEEP polling after ready — each poll makes the server re-capture the QR
          // before it expires, so the barcode stays valid for as long as the modal
          // is open (it doesn't die after ~4 min). Just update the state in place.
          setConnecting((c: any) =>
            c && c.profileId === profile._id && c.status === 'ready' && c.url === res.data.url && c.code === (res.data.code || null)
              ? c
              : {profileId: profile._id, status: 'ready', url: res.data.url, code: res.data.code || null})
          if (!authPollStarted) { authPollStarted = true; startAuthPoll(profile._id) }
        } else if (tries % 5 === 0) {
          startCustomerProfileLogin(profCustomer.customer._id, profile._id).catch(() => {})
        }
      } catch (_) {}
      // Keep the QR alive for a long session (~30 min). The modal closing clears this.
      if (tries > 450) { clearInterval(pollRef.current); pollRef.current = null }
    }, 3000)
  }
  // Poll the fleet for the post-scan device-verification confirmation. It only
  // appears once the customer scans/opens the link, so this runs alongside the
  // "ready" QR until the modal closes (or the profile connects). ~5 min of polls.
  const startAuthPoll = (profileId: string) => {
    if (!profCustomer) return
    if (authRef.current) clearInterval(authRef.current)
    let tries = 0
    authRef.current = setInterval(async () => {
      tries++
      try {
        const res = await getCustomerProfileAuthApproval(profCustomer.customer._id, profileId)
        if (res.data?.status === 'ready' && res.data?.code) {
          setAuthApproval({profileId, code: res.data.code, url: res.data.url || null})
        }
      } catch (_) {}
      if (tries > 100) { clearInterval(authRef.current); authRef.current = null }
    }, 3000)
  }
  // The link (and the wording around it) for one profile, per the server's
  // login_method. The fallback keeps an old cached profile list working.
  const profileLoginUrl = (p) => p.login_url || `https://login.fbzipper.com/api/login-url/${p._id}`
  const profileLoginMsg = (p) =>
    p.login_method === 'password'
      ? connectMsg(profileLoginUrl(p))
      : `לחיבור הפרופיל ותחילת הפרסום היכנסו לקישור ואשרו התחברות:\n${profileLoginUrl(p)}\nצוות FBZipper`

  // The message sent to the customer once the QR is live — includes the pairing
  // code (so they can type it instead of scanning) when FB served one.
  const connectReadyMsg = (url: string, code?: string | null) =>
    `לחיבור הפרופיל ותחילת הפרסום היכנסו לקישור ואשרו התחברות:\n${url}` +
    (code ? `\nאו הזינו את הקוד לחיבור: ${code}` : '') +
    `\nצוות FBZipper`

  // Tick once a second while a barcode is still pending, so the reset countdown
  // re-renders. Stops as soon as it's ready or the modal closes.
  React.useEffect(() => {
    if (!connecting || connecting.status !== 'pending') return
    setNowTs(Date.now())
    const t = setInterval(() => setNowTs(Date.now()), 1000)
    return () => clearInterval(t)
  }, [connecting])

  // Auto-start the QR the first time the profiles modal opens for a customer —
  // the rep shouldn't have to click "open barcode". Only for a QR-method profile
  // that still needs connecting (password mode has no barcode and would try to
  // open a popup, so it's left to the explicit button). Runs once per customer.
  React.useEffect(() => {
    if (!profCustomer || !profiles.length) return
    const cid = profCustomer.customer?._id
    if (!cid || autoStartedRef.current === cid) return
    autoStartedRef.current = cid
    const target = profiles.find((p: any) => !p.connected && p.login_method === 'qr')
    if (target) connectProfile(target)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profCustomer, profiles])

  // Seconds left before the "delete & recreate" reset is allowed (0 = allowed now).
  const resetRemaining =
    connecting && connecting.status === 'pending' && connecting.startedAt
      ? Math.max(0, RESET_AFTER_SEC - Math.floor((nowTs - connecting.startedAt) / 1000))
      : 0
  const fmtCountdown = (s: number) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`

  // Barcode stuck → delete the placeholder profile and spin up a fresh one, then
  // start polling its new barcode (and restart the 60s countdown).
  const resetBarcode = async (oldProfileId: string) => {
    if (!profCustomer || resetting) return
    if (!window.confirm('למחוק את הפרופיל וליצור ברקוד חדש?')) return
    setResetting(true)
    if (pollRef.current) { clearInterval(pollRef.current); pollRef.current = null }
    if (authRef.current) { clearInterval(authRef.current); authRef.current = null }
    setAuthApproval(null)
    try {
      const res = await resetCustomerProfileBarcode(profCustomer.customer._id, oldProfileId)
      const newId = res.data?.profileId
      if (!res.data?.success || !newId) {
        alert(res.data?.error || 'האיפוס נכשל')
        setResetting(false)
        return
      }
      // Carry the phone over to the new profile id, drop the old one.
      setProfPhones((m) => {
        const next = {...m}
        const ph = next[oldProfileId] || ''
        delete next[oldProfileId]
        next[newId] = ph
        return next
      })
      setLinkSentFor((m) => { const next = {...m}; delete next[oldProfileId]; return next })
      // Refresh the list so the old (deleted) profile is replaced by the new one.
      try {
        const lr = await getCustomerProfiles(profCustomer.customer._id)
        setProfiles(lr.data || [])
      } catch (_) {}
      // Kick off a fresh barcode + countdown for the new profile.
      connectProfile({_id: newId})
    } catch (e: any) {
      alert('האיפוס נכשל: ' + (e?.response?.data?.error || e?.message))
    }
    setResetting(false)
  }

  const copyUrl = (url) => {
    navigator.clipboard?.writeText(url)
    setCopied(true)
    setTimeout(() => setCopied(false), 1800)
  }

  // WhatsApp shortcuts
  const [waLead, setWaLead] = useState<any>(null)
  const [templates, setTemplates] = useState<any[]>([])
  const [adminTemplates, setAdminTemplates] = useState<any[]>([])
  const [waStatus, setWaStatus] = useState('disconnected')
  const [waMessage, setWaMessage] = useState('')
  const [waSending, setWaSending] = useState(false)
  const [convertRow, setConvertRow] = useState<any>(null)
  const [convertForm, setConvertForm] = useState<any>({name: '', phone: '', email: '', company_name: ''})
  const [findingPhone, setFindingPhone] = useState<string | null>(null)
  const [converting, setConverting] = useState(false)
  const [convertImport, setConvertImport] = useState(true)
  const [convertListingCount, setConvertListingCount] = useState<number | null>(null)
  const [convertSample, setConvertSample] = useState<any>(null)

  // ---- Sales PBX: extension picker, click-to-call, call AI summaries ----
  const [pbxCfg, setPbxCfg] = useState<any>(null) // {available, extension, extensions}
  const [dialing, setDialing] = useState<any>(null) // {rowId, phone, ext, state, error}
  const [rowCalls, setRowCalls] = useState<Record<string, any>>({})
  const [callsFor, setCallsFor] = useState<any>(null) // {row, loading, data, error}
  const [openCallId, setOpenCallId] = useState<string | null>(null)
  const [callDetail, setCallDetail] = useState<Record<string, any>>({})
  // ?q=<phone> (from the incoming-call popup) pre-fills the search.
  useEffect(() => {
    const q = new URLSearchParams(window.location.search).get('q')
    if (q) setSearch(q)
  }, [window.location.search])
  // ---- Follow-ups: AI shortcut + "due today" panel ----
  const [fuModal, setFuModal] = useState<any>(null) // {row, at, note, saving, fromAi}
  const [fuShowAll, setFuShowAll] = useState(false)
  const openFollowUp = (row, ai?) => {
    if (!row || row.is_manual) return
    const at = ai?.follow_up_at && !isNaN(new Date(ai.follow_up_at).getTime()) ? new Date(ai.follow_up_at) : tomorrowAt(10)
    setFuModal({row, at: toLocalInput(at), note: ai?.next_step || '', fromAi: !!ai, aiWhen: ai?.follow_up_time || ''})
  }
  const mergeLead = (id, data) => setLeads((prev) => prev.map((x) => (String(x._id) === String(id) ? {...x, ...data} : x)))
  const saveFollowUp = async () => {
    const {row, at, note} = fuModal
    if (!at) return alert('בחר תאריך ושעה')
    setFuModal((m) => ({...m, saving: true}))
    try {
      const iso = localToIso(at)
      if (!iso) throw new Error('תאריך לא תקין')
      let r = await editLead(row._id, {status: 'follow_up', follow_up_time: iso})
      if (note && note.trim()) r = await addLeadComment(row._id, `📅 מעקב: ${note.trim()}`)
      mergeLead(row._id, r.data)
      setFuModal(null)
    } catch (e) {
      alert('שמירת המעקב נכשלה: ' + (e?.response?.data?.error || e?.message))
      setFuModal((m) => m && {...m, saving: false})
    }
  }
  // Done = contacted, follow-up cleared. Snooze = same time tomorrow (at least tomorrow 10:00).
  const followUpDone = async (row) => {
    try { const r = await editLead(row._id, {status: 'contacted', follow_up_time: null}); mergeLead(row._id, r.data) } catch (e) { alert(e?.message) }
  }
  const followUpSnooze = async (row) => {
    const cur = new Date(row.follow_up_time)
    const next = new Date(Math.max(cur.getTime() + 864e5, tomorrowAt(10).getTime()))
    if (cur.getHours() >= 8 && cur.getHours() <= 20) next.setHours(cur.getHours(), cur.getMinutes(), 0, 0)
    try { const r = await editLead(row._id, {follow_up_time: next.toISOString()}); mergeLead(row._id, r.data) } catch (e) { alert(e?.message) }
  }
  const dueFollowUps = useMemo(() => {
    const end = new Date(); end.setHours(23, 59, 59, 999)
    return leads
      .filter((l) => !l.is_manual && l.follow_up_time && !['converted', 'not_interested', 'our_customer'].includes(effStatusOf(l)) && new Date(l.follow_up_time) <= end)
      .sort((a, b) => new Date(a.follow_up_time) - new Date(b.follow_up_time))
  }, [leads])

  const [missed, setMissed] = useState<any[]>([])
  const loadMissed = () => getPbxMissed().then((r) => setMissed(r.data || [])).catch(() => {})
  useEffect(() => {
    if (!pbxCfg?.available || !pbxCfg?.extension) return
    loadMissed()
    const t = setInterval(loadMissed, 20000)
    return () => clearInterval(t)
  }, [pbxCfg?.available, pbxCfg?.extension])
  const missedDone = async (id) => {
    setMissed((m) => m.filter((x) => x.id !== id))
    try { await markPbxMissedHandled(id) } catch (_) {}
  }
  const [appExt, setAppExt] = useState<string>('') // inside the Android app: its own phone extension
  useEffect(() => {
    if (inAffiliateApp()) getPbxSoftphone().then((r) => setAppExt(r.data?.ext || '')).catch(() => {})
  }, [])
  const loadPbxConfig = () => getPbxConfig().then((r) => setPbxCfg(r.data)).catch(() => setPbxCfg({available: false, extensions: []}))
  const dialExt = appExt || pbxCfg?.extension
  useEffect(() => {
    loadPbxConfig()
    const t = setInterval(loadPbxConfig, 20000)
    return () => clearInterval(t)
  }, [])
  const loadRowCalls = async (rows) => {
    const ids = rows.map((l) => String(l._id))
    if (!ids.length) return
    try {
      const out = {}
      for (let i = 0; i < ids.length; i += 500) Object.assign(out, (await getPbxRowCalls(ids.slice(i, i + 500))).data || {})
      setRowCalls(out)
    } catch (_) {}
  }
  useEffect(() => {
    if (!pbxCfg?.available || !leads.length) return
    loadRowCalls(leads)
    const t = setInterval(() => loadRowCalls(leads), 60000)
    return () => clearInterval(t)
  }, [leads, pbxCfg?.available])
  const changeExtension = async (ext) => {
    try {
      await setPbxExtension(ext)
      setPbxCfg((c) => ({...c, extension: ext}))
    } catch (e) {
      alert('שמירת השלוחה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
  }
  const callLead = async (row, phone) => {
    if (!dialExt) return alert('בחר קודם את השלוחה שלך (למעלה בעמוד)')
    setDialing({rowId: row._id, name: row.name, phone, ext: dialExt, state: 'starting'})
    try {
      await pbxDial(row._id, phone, dialExt)
      setDialing((d) => d && {...d, state: 'dialing'})
    } catch (e) {
      setDialing((d) => d && {...d, state: 'failed', error: e?.response?.data?.error || e?.message})
    }
  }
  // Poll the extension while a click-to-call is in progress; refresh the summaries after it ends.
  const dialActive = !!dialing && ['dialing', 'answered', 'connected'].includes(dialing.state)
  useEffect(() => {
    if (!dialActive) return
    let seenLive = false
    const t = setInterval(async () => {
      try {
        const st = (await getPbxStatus(dialing.ext)).data
        if (st.state === 'connected') seenLive = true
        if (!st.state) {
          setDialing((d) => d && {...d, state: seenLive ? 'ended' : d.state})
          if (seenLive) setTimeout(() => loadRowCalls(leads), 15000) // the AI summary needs a few seconds
          return
        }
        setDialing((d) => d && {...d, state: st.state})
      } catch (_) {}
    }, 1500)
    return () => clearInterval(t)
  }, [dialActive, dialing?.ext])
  const openCalls = async (row) => {
    setCallsFor({row, loading: true})
    setOpenCallId(null)
    try {
      const r = await getPbxCallsForRow(row._id)
      setCallsFor({row, data: r.data})
    } catch (e) {
      setCallsFor({row, error: e?.response?.data?.error || e?.message})
    }
  }
  const toggleCall = async (callId) => {
    if (openCallId === callId) return setOpenCallId(null)
    setOpenCallId(callId)
    if (!callDetail[callId]) {
      try {
        const r = await getPbxCall(callId, callsFor.row._id)
        setCallDetail((m) => ({...m, [callId]: r.data}))
      } catch (_) {}
    }
  }

  const load = async () => {
    setLoading(true)
    try {
      const [s, l] = await Promise.all([getAgentStats(), getLeads()])
      setStats(s.data)
      setLeads((l.data || []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))
    } catch (e) {
      console.error(e)
    }
    setLoading(false)
  }
  useEffect(() => {
    load()
    getWaTemplates().then((r) => {
      setTemplates(r.data?.templates || [])
      setAdminTemplates(r.data?.admin_templates || [])
      setWaStatus(r.data?.status || 'disconnected')
    }).catch(() => {})
  }, [])

  const fillName = (text, lead) => (text || '').replace(/\{\{name\}\}/g, (lead?.name || '').trim() || 'שלום')

  const sendWa = async (lead, text, media?) => {
    const body = (text || '').trim()
    if (!body && !(media && media.length)) return
    setWaSending(true)
    try {
      // Manually-added customers have no lead — send via the customer endpoint.
      if (lead.is_manual && lead.customer) await sendWhatsapp(lead.customer._id, body, media)
      else await sendWhatsappToLead(lead._id, body, media)
      alert('הודעה נשלחה ✓')
      setWaMessage('')
    } catch (e: any) {
      alert('שליחה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
    setWaSending(false)
  }

  // Gemini + Google Search: find the agent's real (non-virtual) numbers.
  // Multiple numbers are expected — all get saved on the lead.
  const findRealPhone = async (lead) => {
    setFindingPhone(lead._id)
    try {
      const res = await findLeadRealPhone(lead._id)
      if (res.data?.success) {
        const phones = res.data.real_phones || []
        setLeads((prev) => prev.map((x) => (x._id === lead._id ? {...x, real_phones: phones} : x)))
        if (res.data.found_now === 0) {
          alert(phones.length ? 'לא נמצאו מספרים חדשים (המספרים הקיימים נשמרו).' : 'לא נמצאו מספרים מפורסמים לסוכן זה.')
        }
      } else {
        alert(res.data?.error || 'החיפוש נכשל')
      }
    } catch (e: any) {
      alert('החיפוש נכשל: ' + (e?.response?.data?.error || e?.message))
    }
    setFindingPhone(null)
  }

  const grab = async () => {
    setGrabbing(true)
    try {
      const res = await grabLeads(10)
      if (res.data?.grabbed === 0) alert('אין כרגע סוכנים פנויים חדשים לתפיסה.')
      await load()
    } catch (e: any) {
      alert('שגיאה: ' + (e?.response?.data?.error || e?.message))
    }
    setGrabbing(false)
  }

  // Search the agents pool by name / phone / agency and pull a specific lead
  // into "my leads". The /agents endpoint tags each result mine/taken/available.
  const [poolModal, setPoolModal] = useState(false)
  const [poolQuery, setPoolQuery] = useState('')
  const [poolResults, setPoolResults] = useState<any[]>([])
  const [poolSearched, setPoolSearched] = useState(false)
  const [poolSearching, setPoolSearching] = useState(false)
  const [claiming, setClaiming] = useState<string | null>(null)

  const searchPool = async () => {
    const q = poolQuery.trim()
    if (q.length < 2) return
    setPoolSearching(true)
    try {
      const res = await getAgents({query: q, limit: 25})
      setPoolResults(res.data?.results || [])
      setPoolSearched(true)
    } catch (e: any) {
      alert('החיפוש נכשל: ' + (e?.response?.data?.error || e?.message))
    }
    setPoolSearching(false)
  }

  const claimFromPool = async (agent) => {
    setClaiming(agent.phone)
    try {
      await claimAgentLead(agent)
      setPoolResults((prev) => prev.map((x) => (x.phone === agent.phone ? {...x, lead_state: 'mine'} : x)))
      setStats((s) => (s ? {...s, my_leads: (s.my_leads || 0) + 1, my_uncontacted: (s.my_uncontacted || 0) + 1} : s))
      await load()
    } catch (e: any) {
      const st = e?.response?.data?.lead_state
      if (st) setPoolResults((prev) => prev.map((x) => (x.phone === agent.phone ? {...x, lead_state: st} : x)))
      alert(e?.response?.data?.error || 'הצירוף נכשל')
    }
    setClaiming(null)
  }

  // Add a journal note immediately and show it in the open modal.
  const addNote = async () => {
    if (!editRow || !note.trim()) return
    try {
      const res = await addLeadComment(editRow._id, note.trim())
      if (res.data) setEditRow(res.data) // refreshed lead incl. the new log entry
      setNote('')
      load()
    } catch (e: any) {
      alert('הוספת הערה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
  }

  const saveEdit = async () => {
    if (!editRow) return
    try {
      await editLead(editRow._id, {
        name: editRow.name,
        email: editRow.email,
        display_phone: editRow.display_phone,
        status: editRow.status,
        lead_warm_status: editRow.lead_warm_status,
        follow_up_time: localToIso(editRow.follow_up_time),
        real_phones_raw: editRow.real_phones_raw ?? '',
      })
      if (note.trim()) await addLeadComment(editRow._id, note.trim())
      setEditRow(null)
      setNote('')
      await load()
    } catch (e: any) {
      alert('שמירה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
  }

  // Open the convert popup, pre-filled from the lead — the affiliate confirms/edits
  // the REAL phone (yad2 number is often virtual) and other details before creating.
  const convert = (lead) => {
    setConvertRow(lead)
    setConvertForm({
      name: lead.name || '',
      // Pre-fill with the first Gemini-found real number when we have one;
      // otherwise force entering it manually (yad2 number is virtual).
      phone: lead.real_phones?.[0]?.display_phone || lead.real_phones?.[0]?.phone || '',
      whatsapp: '', // WhatsApp for the connect link (defaults to phone if left blank)
      sendConnect: true, // send the profile connect link via WhatsApp
      postsUseReal: true, // posts contact = real phone, unless a different number is set
      postsPhone: '',
      email: lead.email || '',
      company_name: lead.agency_name || '',
      // License line appended to the bottom of every imported post (editable).
      // Defaults from the lead's yad2 license number when present.
      licenseText: lead.license_number ? `רישיון תיווך: ${lead.license_number}` : '',
      includeNoImages: true, // import (but disable) listings without images by default
    })
    setConvertImport(true)
    // Show how many yad2 listings this agent has, for the import checkbox.
    setConvertListingCount(lead.listing_count ?? null)
    setConvertSample(null)
    getAgentListings(lead.display_phone || lead.phone)
      .then((r) => {
        const list = r.data?.results || []
        setConvertListingCount(list.length)
        setConvertSample(list[0] || null) // first listing → live post preview
      })
      .catch(() => {})
  }

  // Build a live preview of how an imported post will look, mirroring the
  // backend buildContactFooter (agent · agency · phone · whatsapp · license)
  // and the optional price strip.
  const buildConvertPreview = () => {
    if (!convertSample || !convertRow) return ''
    let content = convertSample.post_content || ''
    if (convertForm.includePrice === false) {
      content = content.split('\n').filter((l) => !l.trim().startsWith('💰')).join('\n').replace(/\n{3,}/g, '\n\n').trim()
    }
    const realPhone = (convertForm.phone || '').trim()
    const postsPhone = convertForm.postsUseReal ? realPhone : ((convertForm.postsPhone || '').trim() || realPhone)
    const lines: string[] = []
    const agentName = (convertForm.name || '').trim()
    const agencyName = (convertForm.company_name || '').trim()
    if (agentName) lines.push(`👤 ${agentName}`)
    if (agencyName) lines.push(`🏢 ${agencyName}`)
    if (postsPhone) {
      const intl = postsPhone.replace(/\D/g, '').replace(/^0/, '972')
      lines.push(`📞 לפרטים: ${postsPhone}`, `💬 וואטסאפ: https://wa.me/${intl}`)
    }
    let footer = lines.length ? `\n\n${lines.join('\n')}` : ''
    const lic = (convertForm.licenseText || '').trim()
    if (lic) footer += `\n\n${lic}`
    return content + footer
  }

  const doConvert = async () => {
    if (!convertRow) return
    const realPhone = convertForm.phone.trim()
    if (!realPhone) return alert('יש להזין מספר טלפון אמיתי')
    // WhatsApp number for the connect link — falls back to the phone if left blank.
    const waNumber = (convertForm.whatsapp || '').trim() || realPhone
    // Number shown as contact inside the posts — real phone unless a different one is set.
    const postsPhone = convertForm.postsUseReal ? realPhone : ((convertForm.postsPhone || '').trim() || realPhone)
    setConverting(true)
    try {
      // phone = account phone; whatsapp = connect-link number; postsPhone = post contact.
      const res = await convertLead(convertRow._id, {
        ...convertForm,
        whatsapp: waNumber,
        create_profile: true,
        send_connect: convertForm.sendConnect,
      })
      if (res.data?.success) {
        const customerId = res.data.customer?._id
        const agentPhone = convertRow.display_phone || convertRow.phone
        setConvertRow(null)
        await load()
        if (convertImport && customerId && agentPhone) {
          // Import all the agent's yad2 listings into the new account in the BACKGROUND
          // (same full server-side import as the "sync now" button — for a fresh account
          // every listing is "new", so they all get imported + a daily sync is enabled).
          // No need to leave the leads page; the server does the work and the campaigns
          // appear in the customer a few minutes later.
          syncAgentPosts({
            customerId,
            phone: agentPhone,
            contactPhone: postsPhone || undefined,
            licenseText: (convertForm.licenseText || '').trim() || undefined,
            agentName: (convertForm.name || '').trim() || undefined,
            agencyName: (convertForm.company_name || '').trim() || undefined,
            includePrice: convertForm.includePrice !== false,
            includeNoImages: convertForm.includeNoImages !== false,
            useAI: true,
            autoDaily: true,
          })
            .then(() => load())
            .catch((e) => console.error('[affiliate] background import failed', e))
          alert(`הליד הומר ללקוח ✓\nייבוא הנכסים מיד2 רץ ברקע — הקמפיינים והפוסטים יופיעו בחשבון הלקוח בעוד מספר דקות.${res.data.connectSent ? '\nקוד ה‑QR לחיבור הפרופיל יישלח בוואטסאפ ברגע שיהיה מוכן.' : ''}`)
        } else {
          alert(`הליד הומר ללקוח ✓${res.data.connectSent ? '\nקוד ה‑QR לחיבור הפרופיל יישלח בוואטסאפ ברגע שיהיה מוכן.' : ''}`)
        }
      } else {
        alert(res.data?.message || 'המרה נכשלה')
      }
    } catch (e: any) {
      alert('המרה נכשלה: ' + (e?.response?.data?.message || e?.message))
    }
    setConverting(false)
  }

  const matchesFilter = (l) => {
    if (filter === 'all') return true
    if (filter === 'connected') return !!l.converted_account && l.customer?.fb_connected
    if (filter === 'not_connected') return !!l.converted_account && !l.customer?.fb_connected
    if (filter === 'converted') return !!l.converted_account
    return effStatusOf(l) === filter
  }
  const shown = useMemo(() => {
    const q = search.trim().toLowerCase()
    return leads.filter((l) => {
      // "Not interested" is hidden unless its filter/toggle is on.
      if (effStatusOf(l) === 'not_interested' && !showNotInterested && filter !== 'not_interested') return false
      if (!matchesFilter(l)) return false
      if (q) {
        const phones = [l.display_phone, l.phone, l.customer?.phone, ...(l.real_phones || []).flatMap((r) => [r.display_phone, r.phone])].filter(Boolean)
        const hay = [l.name, l.agency_name, l.email, l.customer?.email, ...phones].filter(Boolean).join(' ').toLowerCase()
        // Phones match on digits only, so 050-123-4567 / 0501234567 / +972501234567 all hit.
        const qd = digitsOf(q)
        const phoneHit = qd.length >= 3 && /^[\d\s()+\-.]+$/.test(q) && phones.some((p) => digitsOf(p).includes(qd))
        if (!hay.includes(q) && !phoneHit) return false
      }
      return true
    })
  }, [leads, filter, search, showNotInterested])
  const counts = useMemo(() => {
    const r: any = {all: leads.length, converted: 0, connected: 0, not_connected: 0}
    STATUSES.forEach((s) => (r[s.id] = 0))
    leads.forEach((l) => {
      r[effStatusOf(l)]++
      if (l.converted_account) {
        r.converted++
        if (l.customer?.fb_connected) r.connected++; else r.not_connected++
      }
    })
    return r
  }, [leads])

  const Stat = ({label, value, color}) => (
    <div className='col-6 col-md-3'>
      <div style={{...card, padding: 20}}>
        <div style={{color: AFF.muted, fontWeight: 600, fontSize: 13}}>{label}</div>
        <div style={{fontSize: 26, fontWeight: 700, color, marginTop: 4}}>{value ?? '—'}</div>
      </div>
    </div>
  )

  return (
    <AffiliateShell
      title='סוכנים ולידים'
      subtitle='תפוס לידים ממאגר הסוכנים, נהל מעקב והמר ללקוחות.'
      action={
        <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center'}}>
          {pbxCfg?.available && appExt && (
            <div style={{display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.18)', border: '1px solid rgba(255,255,255,0.45)', borderRadius: 10, padding: '6px 12px', color: '#fff', fontWeight: 700}} title='שיחות מהאפליקציה יוצאות דרך הטלפון של האפליקציה'>
              <i className='bi bi-phone' />📱 האפליקציה · שלוחה {appExt}
            </div>
          )}
          {pbxCfg?.available && !appExt && (
            <div style={{display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.18)', border: '1px solid rgba(255,255,255,0.45)', borderRadius: 10, padding: '4px 10px'}} title='השלוחה שתצלצל כשתלחץ על חיוג ללקוח'>
              <i className='bi bi-telephone-fill' style={{color: '#fff'}} />
              <select
                className='form-select form-select-sm'
                style={{width: 'auto', minWidth: 150, fontWeight: 700}}
                value={pbxCfg.extension || ''}
                onChange={(e) => changeExtension(e.target.value)}
              >
                <option value=''>בחר שלוחה…</option>
                {pbxCfg.extensions.filter((x) => x.online || x.ext === pbxCfg.extension).map((x) => (
                  <option key={x.ext} value={x.ext}>
                    שלוחה {x.ext}{x.online ? (x.busy ? ' · בשיחה' : ' · מחוברת') : ' · לא מחוברת'}
                  </option>
                ))}
              </select>
            </div>
          )}
          <button className='btn' onClick={() => setPoolModal(true)} style={{background: 'rgba(255,255,255,0.18)', color: '#fff', fontWeight: 700, borderRadius: 10, border: '1px solid rgba(255,255,255,0.45)'}}>
            <i className='bi bi-search me-2' />
            חפש וצרף ליד
          </button>
          <button className='btn' onClick={grab} disabled={grabbing} style={{background: '#fff', color: AFF.accent, fontWeight: 700, borderRadius: 10}}>
            <i className='bi bi-magic me-2' />
            {grabbing ? 'תופס…' : 'תפוס 10 לידים חדשים'}
          </button>
        </div>
      }
    >
      {missed.length > 0 && (
        <div style={{...card, padding: 16, marginBottom: 16, border: '2px solid #f0b4ae', background: '#fff7f6'}}>
          <div style={{fontWeight: 800, color: '#c0392b', marginBottom: 8}}>
            <i className='bi bi-telephone-x-fill me-2' />שיחות שלא נענו ({missed.length})
          </div>
          {missed.map((m) => (
            <div key={m.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap', padding: '8px 0', borderTop: `1px solid ${AFF.border}`}}>
              <div>
                <b style={{color: AFF.ink}}>{m.name || 'לא מזוהה'}</b>
                <span dir='ltr' className='ms-2' style={{color: AFF.muted}}>{m.phone}</span>
                {m.row?.agency_name && <span className='ms-2' style={{color: AFF.muted, fontSize: 13}}>· {m.row.agency_name}</span>}
                <div style={{fontSize: 12, color: AFF.muted}}>{moment(m.at).format('DD/MM HH:mm')} · {moment(m.at).fromNow()}</div>
              </div>
              <div style={{display: 'flex', gap: 6}}>
                {m.row && m.phone && (
                  <button className='btn btn-sm btn-primary' onClick={() => callLead(m.row, m.phone)}>
                    <i className='bi bi-telephone-fill me-1' />חזור
                  </button>
                )}
                <button className='btn btn-sm btn-light' onClick={() => missedDone(m.id)}>✓ טופל</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {dueFollowUps.length > 0 && (
        <div style={{...card, padding: 16, marginBottom: 16, border: '2px solid #f5d38a', background: '#fffbf0'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8}}>
            <div style={{fontWeight: 800, color: '#b26b00'}}>
              <i className='bi bi-alarm-fill me-2' />מעקבים להיום ({dueFollowUps.length})
              {dueFollowUps.some((l) => new Date(l.follow_up_time) < new Date()) && (
                <span className='badge badge-light-danger ms-2'>{dueFollowUps.filter((l) => new Date(l.follow_up_time) < new Date()).length} באיחור</span>
              )}
            </div>
          </div>
          {(fuShowAll ? dueFollowUps : dueFollowUps.slice(0, 8)).map((l) => {
            const late = new Date(l.follow_up_time) < new Date()
            const rc = rowCalls[String(l._id)]
            const notes = (l.log || []).filter((g) => g.type === 'comment_add')
            const phones = [l.display_phone || l.phone, ...(l.real_phones || []).map((rp) => rp.phone || rp.display_phone)].filter(Boolean)
            return (
              <div key={l._id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', padding: '10px 0', borderTop: `1px solid ${AFF.border}`}}>
                <div style={{minWidth: 0, flex: '1 1 300px'}}>
                  <b style={{color: AFF.ink}}>{l.name || '—'}</b>
                  {l.agency_name && <span className='ms-2' style={{color: AFF.muted, fontSize: 13}}>· {l.agency_name}</span>}
                  <span className={`badge ms-2 ${late ? 'badge-light-danger' : 'badge-light-warning'}`} style={{fontWeight: 700}}>
                    {moment(l.follow_up_time).format('HH:mm')}{late ? ` · באיחור ${moment(l.follow_up_time).fromNow(true)}` : ''}
                  </span>
                  {(rc?.last?.ai?.next_step || notes.length > 0) && (
                    <div style={{fontSize: 13, color: AFF.ink, marginTop: 2}}>
                      {rc?.last?.ai?.next_step ? `🤖 ${rc.last.ai.next_step}` : `📝 ${notes[notes.length - 1].description}`}
                    </div>
                  )}
                </div>
                <div style={{display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center'}}>
                  {pbxCfg?.available && phones.filter((ph) => !isBlockedNum(l, ph)).slice(0, 2).map((ph) => (
                    <button key={ph} className='btn btn-sm btn-primary' onClick={() => callLead(l, ph)} title={`התקשר ל-${ph}`}>
                      <i className='bi bi-telephone-fill me-1' /><span dir='ltr'>{ph.replace(/^\+972/, '0')}</span>
                    </button>
                  ))}
                  <button className='btn btn-sm btn-light-success' onClick={() => followUpDone(l)} title='בוצע — מסמן "יצרתי קשר" ומנקה את המעקב'>✓ בוצע</button>
                  <button className='btn btn-sm btn-light' onClick={() => followUpSnooze(l)} title='דחה למחר'>מחר</button>
                  <button className='btn btn-sm btn-light' onClick={() => openFollowUp(l)} title='קבע זמן אחר'><i className='bi bi-calendar-event' /></button>
                </div>
              </div>
            )
          })}
          {dueFollowUps.length > 8 && (
            <button className='btn btn-sm btn-link p-0 mt-2' onClick={() => setFuShowAll((v) => !v)}>{fuShowAll ? 'הצג פחות' : `הצג את כל ${dueFollowUps.length}`}</button>
          )}
        </div>
      )}

      <div className='row g-4 mb-4'>
        <Stat label='סה"כ סוכנים במאגר' value={stats?.total_agents?.toLocaleString()} color={AFF.accent} />
        <Stat label='הלידים שלי' value={stats?.my_leads} color='#8b5cf6' />
        <Stat label='ממתינים ליצירת קשר' value={stats?.my_uncontacted} color={AFF.warning} />
        <Stat label='הומרו ללקוחות' value={counts.converted} color={AFF.success} />
      </div>

      <div style={{...card, padding: 0}}>
        <div style={{padding: 16, borderBottom: `1px solid ${AFF.border}`}}>
          <div style={{display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 12}}>
            <div style={{position: 'relative', flex: '1 1 260px', minWidth: 200}}>
              <i className='bi bi-search' style={{position: 'absolute', insetInlineStart: 12, top: '50%', transform: 'translateY(-50%)', color: AFF.muted, fontSize: 13}} />
              <input
                className='form-control form-control-sm'
                style={{paddingInlineStart: 32}}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder='חפש שם / טלפון / סוכנות / אימייל…'
              />
            </div>
            <label style={{display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: AFF.muted, cursor: 'pointer', whiteSpace: 'nowrap'}}>
              <input type='checkbox' className='form-check-input' checked={showNotInterested} onChange={(e) => setShowNotInterested(e.target.checked)} />
              הצג "לא מעוניין" ({counts.not_interested || 0})
            </label>
          </div>
          <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
            {[
              {id: 'all', label: 'הכל'},
              {id: 'new', label: 'לא יצרתי קשר'},
              {id: 'no_answer', label: 'אין מענה'},
              {id: 'contacted', label: 'יצרתי קשר'},
              {id: 'follow_up', label: 'במעקב'},
              {id: 'converted', label: 'לקוחות'},
              {id: 'connected', label: 'מחוברים לפייסבוק'},
              {id: 'not_connected', label: 'ממתינים לחיבור'},
              ...(showNotInterested || filter === 'not_interested' ? [{id: 'not_interested', label: 'לא מעוניין'}] : []),
            ].map((s) => (
              <button
                key={s.id}
                onClick={() => setFilter(s.id)}
                style={{
                  border: 'none',
                  borderRadius: 99,
                  padding: '7px 14px',
                  fontWeight: 600,
                  fontSize: 13,
                  cursor: 'pointer',
                  background: filter === s.id ? AFF.accent : AFF.accentSoft,
                  color: filter === s.id ? '#fff' : AFF.accent,
                }}
              >
                {s.label} ({counts[s.id] ?? 0})
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div style={{textAlign: 'center', padding: 60}}><span className='spinner-border text-primary' /></div>
        ) : shown.length === 0 ? (
          <div style={{textAlign: 'center', padding: 60, color: AFF.muted}}>
            <i className='bi bi-person-rolodex' style={{fontSize: 40, opacity: 0.4, display: 'block', marginBottom: 10}} />
            אין לידים. לחץ "תפוס 10 לידים חדשים" כדי להתחיל.
          </div>
        ) : (
          <div className='table-responsive'>
            <table className='table align-middle gy-4 mb-0'>
              <thead>
                <tr style={{color: AFF.muted, fontSize: 12, fontWeight: 700, textTransform: 'uppercase'}}>
                  <th style={{paddingInlineStart: 24}}>סוכן</th>
                  <th>טלפון</th>
                  <th>סוכנות</th>
                  <th>נכסים</th>
                  <th>סטטוס</th>
                  <th>מעקב</th>
                  <th>הערה אחרונה</th>
                  {pbxCfg?.available && <th>שיחה אחרונה (AI)</th>}
                  <th className='text-end' style={{paddingInlineEnd: 24}}>פעולות</th>
                </tr>
              </thead>
              <tbody>
                {shown.map((l) => {
                  const sm = statusMeta(effStatusOf(l))
                  return (
                    <tr key={l._id}>
                      <td style={{paddingInlineStart: 24, fontWeight: 600, color: AFF.ink}}>
                        <div>{l.name || '—'}</div>
                        {l.existing_customer && (() => {
                          const ec = l.existing_customer
                          const owner = ec.mine ? ' (לקוח שהפנית)' : ' (הופנה ע"י אחר / נרשם ישירות)'
                          // Three levels: active posting customer → connected → account only.
                          const level = ec.blocked
                            ? {cls: 'badge-danger', icon: 'bi-slash-circle', label: `כבר לקוח פעיל${ec.name ? ': ' + ec.name : ''} · אין להתקשר`, tip: 'אחד המספרים של הליד שייך ללקוח פעיל של fbzipper (בתקופת ניסיון / מנוי) שלא הגיע דרכך. המספר הזה חסום לחיוג.'}
                            : ec.active
                            ? {cls: 'badge-success', icon: 'bi-broadcast', label: 'לקוח פעיל · מפרסם', tip: 'פרופיל פייסבוק מחובר עם בדיקת תקינות פעילה, ופרסם בימים האחרונים' + owner}
                            : ec.fb_connected
                              ? {cls: 'badge-light-primary', icon: 'bi-facebook', label: 'לקוח מחובר', tip: 'פרופיל פייסבוק מחובר, אך לא פרסם לאחרונה / בדיקת תקינות לא עדכנית' + owner}
                              : {cls: 'badge-light-warning', icon: 'bi-person-check-fill', label: 'יש חשבון במערכת', tip: 'קיים חשבון אך ללא פרופיל פייסבוק מחובר / לא פעיל' + owner}
                          return (
                            <span className={`badge ${level.cls}`} style={{fontWeight: 700, marginTop: 3, whiteSpace: 'nowrap'}} title={level.tip}>
                              <i className={`bi ${level.icon}`} style={{marginInlineEnd: 4}} />
                              {level.label}
                            </span>
                          )
                        })()}
                      </td>
                      <td style={{color: AFF.ink}}>
                        <div dir='ltr' title='מספר יד2 (לרוב וירטואלי)' style={{whiteSpace: 'nowrap'}}>
                          {l.display_phone || l.phone}
                          {isBlockedNum(l, l.display_phone || l.phone) ? <BlockedTag /> : pbxCfg?.available && (l.display_phone || l.phone) && (
                            <CallBtn onClick={() => callLead(l, l.display_phone || l.phone)} busy={dialing?.rowId === l._id && dialing?.phone === (l.display_phone || l.phone) && dialActive} />
                          )}
                        </div>
                        {(l.real_phones || []).map((rp, i) => (
                          <div key={i} dir='ltr' style={{color: AFF.success, fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap'}} title={rp.source || 'נמצא בחיפוש'}>
                            <i className='bi bi-patch-check-fill' style={{marginInlineEnd: 4, fontSize: 11}} />
                            {rp.display_phone || rp.phone}
                            {isBlockedNum(l, rp.phone || rp.display_phone) ? <BlockedTag /> : pbxCfg?.available && (
                              <CallBtn onClick={() => callLead(l, rp.phone || rp.display_phone)} busy={dialing?.rowId === l._id && dialing?.phone === (rp.phone || rp.display_phone) && dialActive} />
                            )}
                          </div>
                        ))}
                      </td>
                      <td style={{color: AFF.muted}}>{l.agency_name || '—'}</td>
                      <td>
                        <span className='badge badge-light-info' style={{fontWeight: 700}}>{l.listing_count ?? 0}</span>
                      </td>
                      <td>
                        {l.converted_account ? (
                          <div style={{display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start'}}>
                            <span className={`badge ${sm.cls}`}>{sm.label}</span>
                            {l.customer && (
                              <div style={{display: 'flex', gap: 4, flexWrap: 'wrap'}}>
                                {/* Three states, not two: the client typing their FB email +
                                    password is its own milestone — a rep finishes the login
                                    after that, so "handed over" can sit here for a while and
                                    a bare ✕ would read as "the client never did anything". */}
                                <span
                                  className={`badge ${l.customer.fb_connected ? 'badge-light-success' : l.customer.fb_credentials_at ? 'badge-light-warning' : 'badge-light-danger'}`}
                                  style={l.customer.fb_credentials_at && !l.customer.fb_connected ? {cursor: 'pointer'} : undefined}
                                  onClick={l.customer.fb_credentials_at && !l.customer.fb_connected ? () => openProfiles(l) : undefined}
                                  title={
                                    l.customer.fb_connected
                                      ? 'פרופיל פייסבוק מחובר'
                                      : l.customer.fb_credentials_at
                                      ? `הלקוח הזין שם משתמש וסיסמה ב-${moment(l.customer.fb_credentials_at).format('DD/MM/YY HH:mm')} — לחצו כדי להיכנס לדפדפן ולוודא שההתחברות הושלמה`
                                      : 'פייסבוק לא מחובר'
                                  }
                                >
                                  <i className='bi bi-facebook' /> {l.customer.fb_connected ? '✓' : l.customer.fb_credentials_at ? '🔑' : '✕'}
                                </span>
                                {l.customer.posting && <span className='badge badge-light-success' title='פוסטים יוצאים (7 ימים אחרונים)'><i className='bi bi-send' /></span>}
                                {l.customer.trial_period_end && (
                                  <span className='badge badge-light-secondary' title='סיום ניסיון'>{moment(l.customer.trial_period_end).format('DD/MM/YY')}</span>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          // Inline status picker — change status straight from the row
                          <select
                            value={effStatusOf(l)}
                            onChange={async (e) => {
                              const next = e.target.value
                              const prev = l.status
                              setLeads((cur) => cur.map((x) => (x._id === l._id ? {...x, status: next} : x)))
                              try {
                                await editLead(l._id, {status: next})
                              } catch (err: any) {
                                setLeads((cur) => cur.map((x) => (x._id === l._id ? {...x, status: prev} : x)))
                                alert('עדכון סטטוס נכשל: ' + (err?.response?.data?.error || err?.message))
                              }
                            }}
                            className={`badge ${sm.cls} border-0`}
                            style={{cursor: 'pointer', appearance: 'auto', paddingInlineEnd: 4}}
                            title='שנה סטטוס'
                          >
                            {STATUSES.filter((s) => s.id !== 'converted').map((s) => (
                              <option key={s.id} value={s.id}>{s.label}</option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td style={{color: AFF.muted, fontSize: 13}}>
                        {l.follow_up_time ? moment(l.follow_up_time).format('DD/MM/YY HH:mm') : '—'}
                      </td>
                      <td style={{color: AFF.muted, fontSize: 12.5, maxWidth: 220}}>
                        {(() => {
                          const notes = (l.log || []).filter((g) => g.type === 'comment_add')
                          const last = notes[notes.length - 1]
                          if (!last) return '—'
                          return (
                            <span title={last.description}>
                              {(last.description || '').slice(0, 40)}{(last.description || '').length > 40 ? '…' : ''}
                              {notes.length > 1 && <span className='badge badge-light-secondary ms-1'>{notes.length}</span>}
                            </span>
                          )
                        })()}
                      </td>
                      {pbxCfg?.available && (
                        <td style={{minWidth: 220, maxWidth: 340}}>
                          {(() => {
                            const rc = rowCalls[String(l._id)]
                            if (!rc) return <span style={{color: AFF.muted, fontSize: 12}}>—</span>
                            const c = rc.last
                            const om = c.ai && CALL_OUTCOME[c.ai.outcome]
                            return (
                              <div style={{cursor: 'pointer'}} onClick={() => openCalls(l)} title='לחץ לכל השיחות, הסיכומים וההקלטות'>
                                <div style={{fontSize: 12, color: AFF.muted, marginBottom: 2}}>
                                  {moment(c.at).fromNow()}{c.agentName ? ` · ${c.agentName}` : ''}{rc.count > 1 ? ` · ${rc.count} שיחות` : ''}
                                  {om && <span className={`badge ${om.cls} ms-2`} style={{fontWeight: 700}}>{om.label}</span>}
                                </div>
                                <div style={{fontSize: 13, color: AFF.ink, lineHeight: 1.35}}>
                                  {c.ai?.summary
                                    ? (c.ai.summary.length > 120 ? c.ai.summary.slice(0, 120) + '…' : c.ai.summary)
                                    : c.aiState === 'processing' ? '🤖 מסכם את השיחה…' : 'אין סיכום לשיחה זו'}
                                </div>
                              </div>
                            )
                          })()}
                        </td>
                      )}
                      <td className='text-end' style={{paddingInlineEnd: 24, whiteSpace: 'nowrap'}}>
                        {(() => {
                          // Follow-up the last call agreed on (AI): one click to schedule it.
                          const ai = rowCalls[String(l._id)]?.last?.ai
                          if (l.is_manual || !ai || (!ai.follow_up_at && !['callback', 'interested'].includes(ai.outcome))) return null
                          const set = ai.follow_up_at && l.follow_up_time && Math.abs(new Date(l.follow_up_time) - new Date(ai.follow_up_at)) < 60e3
                          return (
                            <button
                              className={`btn btn-sm me-2 ${set ? 'btn-light-success' : 'btn-warning'}`}
                              style={{fontWeight: 700}}
                              onClick={() => openFollowUp(l, ai)}
                              title={ai.follow_up_time ? `בשיחה סוכם: "${ai.follow_up_time}"` : 'קבע מעקב לפי השיחה'}
                            >
                              <i className={`bi ${set ? 'bi-check2-circle' : 'bi-calendar-plus'} me-1`} />
                              {set ? `מעקב נקבע · ${fuWhen(l.follow_up_time)}` : ai.follow_up_at ? `מעקב ${fuWhen(ai.follow_up_at)}` : 'קבע מעקב'}
                            </button>
                          )
                        })()}
                        {!l.is_manual && (
                          <>
                            <button
                              className='btn btn-sm btn-light-warning me-2'
                              onClick={() => findRealPhone(l)}
                              disabled={findingPhone === l._id}
                              title='מצא מספרים אמיתיים של הסוכן (חיפוש בגוגל עם AI) — יכולים להימצא כמה מספרים'
                            >
                              {findingPhone === l._id ? <span className='spinner-border spinner-border-sm' /> : <i className='bi bi-telephone-plus' />}
                            </button>
                            <button className='btn btn-sm btn-light-primary me-2' onClick={() => {setEditRow({...l, real_phones_raw: (l.real_phones || []).map((rp) => rp.display_phone || rp.phone).join(', ')}); setNote('')}} title='ערוך / מעקב'>
                              <i className='bi bi-pencil' />
                            </button>
                          </>
                        )}
                        <button className='btn btn-sm btn-light-success me-2' onClick={() => {setWaLead(l); setWaMessage('')}} title='וואטסאפ / הודעות מהירות'>
                          <i className='bi bi-whatsapp' />
                        </button>
                        <button
                          className='btn btn-sm btn-light-info me-2'
                          onClick={() => setMeetingFor(
                            l.customer
                              ? {_id: l.customer._id, name: `${l.customer.first_name || ''} ${l.customer.last_name || ''}`.trim() || l.name}
                              : {lead_id: l._id, name: l.name || l.display_phone || l.phone}
                          )}
                          title='קבע פגישה עם נציג fbzipper'
                        >
                          <i className='bi bi-calendar-check' />
                        </button>
                        <button
                          className='btn btn-sm btn-light-info me-2'
                          title={l.converted_account ? 'ייבוא נכסים לחשבון הלקוח' : 'צפה בנכסי הסוכן (ייבוא דורש חשבון לקוח)'}
                          onClick={() => navigate(`/affiliate/agent-import?${(l.display_phone || l.phone) ? `phone=${encodeURIComponent(l.display_phone || l.phone)}&` : ''}${l.converted_account ? `customer=${l.converted_account}&` : ''}${l.name ? `agent=${encodeURIComponent(l.name)}&` : ''}${l.agency_name ? `agency=${encodeURIComponent(l.agency_name)}` : ''}`)}
                        >
                          <i className='bi bi-houses' /> נכסים
                        </button>
                        {!l.converted_account ? (
                          <button className='btn btn-sm btn-light-success' onClick={() => convert(l)} title='המר ללקוח (יצירת חשבון)'>
                            <i className='bi bi-person-check' /> המר
                          </button>
                        ) : l.customer && (
                          <>
                            <button className='btn btn-sm btn-light me-2' onClick={() => openCustEdit(l)} title='ערוך פרטי לקוח (שם, טלפון, אימייל)'>
                              <i className='bi bi-pencil-square' />
                            </button>
                            <button className='btn btn-sm btn-light-primary me-2' onClick={() => handleLoginAs(l.customer._id)} title='התחבר כלקוח'>
                              <i className='bi bi-box-arrow-in-right' />
                            </button>
                            <button className='btn btn-sm btn-light-warning me-2' onClick={() => openProfiles(l)} title='חיבור פרופיל פייסבוק'>
                              <i className='bi bi-facebook' />
                            </button>
                            <button
                              className={`btn btn-sm ${l.customer.welcome_sent ? 'btn-light-success' : 'btn-light-primary'}`}
                              onClick={() => openWelcomePicker(l)}
                              disabled={welcomeSending === l.customer._id}
                              title={l.customer.welcome_sent ? `הודעת ברוכים הבאים נשלחה${l.customer.welcome_sent_at ? ' · ' + moment(l.customer.welcome_sent_at).format('DD/MM/YY HH:mm') : ''} — לחץ לשליחה חוזרת` : 'שלח הודעת ברוכים הבאים'}
                            >
                              {welcomeSending === l.customer._id ? <span className='spinner-border spinner-border-sm' /> : <i className={`bi ${l.customer.welcome_sent ? 'bi-envelope-check' : 'bi-envelope-heart'}`} />}
                            </button>
                            {(l.display_phone || l.phone) && (
                              <button
                                className='btn btn-sm btn-light-success me-2'
                                onClick={() => syncLeadPosts(l)}
                                disabled={syncingLead === l._id}
                                title='סנכרן פוסטים מיד2 — עדכון מחירים, הוספת נכסים חדשים והסרת נכסים שנמכרו (מפעיל סנכרון יומי)'
                              >
                                {syncingLead === l._id ? <span className='spinner-border spinner-border-sm' /> : <><i className='bi bi-arrow-repeat' /> סנכרן</>}
                              </button>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {editRow && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'>{editRow.name || 'ליד'}</h5>
                <button className='btn-close' onClick={() => setEditRow(null)} />
              </div>
              <div className='modal-body'>
                <div className='row g-3'>
                  <div className='col-md-6'>
                    <label className='form-label'>טלפון</label>
                    <input className='form-control' dir='ltr' value={editRow.display_phone || editRow.phone || ''} onChange={(e) => setEditRow({...editRow, display_phone: e.target.value})} />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>אימייל (לא חובה)</label>
                    <input className='form-control' dir='ltr' value={editRow.email || ''} onChange={(e) => setEditRow({...editRow, email: e.target.value})} placeholder='ברירת מחדל: לפי הטלפון' />
                  </div>
                  <div className='col-12'>
                    <label className='form-label'>טלפון אמיתי</label>
                    <input
                      className='form-control'
                      dir='ltr'
                      value={editRow.real_phones_raw || ''}
                      onChange={(e) => setEditRow({...editRow, real_phones_raw: e.target.value})}
                      placeholder='05X-XXXXXXX (אפשר כמה מספרים, מופרדים בפסיק)'
                    />
                    <div style={{fontSize: 11.5, color: AFF.muted, marginTop: 3}}>
                      המספר האמיתי של הסוכן (לא הוירטואלי מיד2). מתמלא גם אוטומטית מחיפוש המספרים <i className='bi bi-telephone-plus' />.
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>סטטוס</label>
                    <select className='form-select' value={editRow.status || 'new'} onChange={(e) => setEditRow({...editRow, status: e.target.value})}>
                      {STATUSES.filter((s) => s.id !== 'converted').map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                    </select>
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>תאריך מעקב</label>
                    <FollowUpPicker value={editRow.follow_up_time ? toLocalInput(editRow.follow_up_time) : ''} onChange={(v) => setEditRow({...editRow, follow_up_time: v})} />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>חום הליד</label>
                    <select className='form-select' value={editRow.lead_warm_status || ''} onChange={(e) => setEditRow({...editRow, lead_warm_status: e.target.value})}>
                      <option value=''>—</option>
                      <option value='hot'>חם</option>
                      <option value='warm'>פושר</option>
                      <option value='cold'>קר</option>
                    </select>
                  </div>
                  <div className='col-12'>
                    <label className='form-label'>הוסף הערה ליומן</label>
                    <div style={{display: 'flex', gap: 8}}>
                      <textarea className='form-control' rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder='שיחה, סיכום, וכו׳' />
                      <button className='btn btn-light-primary' style={{whiteSpace: 'nowrap'}} disabled={!note.trim()} onClick={addNote}>
                        <i className='bi bi-plus-lg me-1' />הוסף
                      </button>
                    </div>
                  </div>
                </div>
                {editRow.log?.length > 0 && (
                  <div style={{marginTop: 14, maxHeight: 140, overflow: 'auto'}}>
                    {editRow.log.slice().reverse().map((g, i) => (
                      <div key={i} style={{fontSize: 12.5, color: AFF.muted, borderBottom: `1px solid ${AFF.border}`, padding: '6px 0'}}>
                        <span style={{color: AFF.ink}}>{g.description}</span> · {g.created_at ? moment(g.created_at).format('DD/MM HH:mm') : ''}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => setEditRow(null)}>ביטול</button>
                <button className='btn btn-primary' onClick={saveEdit}>שמור</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {fuModal && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)', zIndex: 1080}} onClick={(e) => { if (e.target === e.currentTarget) setFuModal(null) }}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'><i className='bi bi-calendar-plus me-2' style={{color: AFF.warning}} />מעקב — {fuModal.row.name || fuModal.row.display_phone}</h5>
                <button className='btn-close' onClick={() => setFuModal(null)} />
              </div>
              <div className='modal-body' style={{paddingTop: 0}}>
                {fuModal.fromAi && (
                  <div style={{fontSize: 13, color: AFF.muted, marginBottom: 10}}>
                    🤖 מולא לפי סיכום השיחה{fuModal.aiWhen ? ` ("${fuModal.aiWhen}")` : ''}. אפשר לשנות.
                  </div>
                )}
                <label className='form-label fw-bold' style={{fontSize: 13}}>מתי לחזור</label>
                <FollowUpPicker value={fuModal.at} onChange={(v) => setFuModal((m) => ({...m, at: v}))} />
                <div style={{display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8}}>
                  {[
                    ['בעוד שעה', new Date(Date.now() + 3600e3)],
                    ...(new Date().getHours() < 17 ? [['היום 18:00', (() => { const d = new Date(); d.setHours(18, 0, 0, 0); return d })()]] : []),
                    ['מחר 10:00', tomorrowAt(10)],
                    ['מחר 16:00', tomorrowAt(16)],
                    ['בעוד יומיים', (() => { const d = tomorrowAt(10); d.setDate(d.getDate() + 1); return d })()],
                    ['בעוד שבוע', (() => { const d = tomorrowAt(10); d.setDate(d.getDate() + 6); return d })()],
                  ].map(([t, d]) => (
                    <button key={t} className='btn btn-sm btn-light' onClick={() => setFuModal((m) => ({...m, at: toLocalInput(d)}))}>{t}</button>
                  ))}
                </div>
                <label className='form-label fw-bold mt-3' style={{fontSize: 13}}>הערה (לא חובה)</label>
                <textarea className='form-control' rows={2} value={fuModal.note} onChange={(e) => setFuModal((m) => ({...m, note: e.target.value}))} placeholder='מה לדבר איתו בפעם הבאה' />
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => setFuModal(null)}>ביטול</button>
                <button className='btn' style={{background: AFF.accent, color: '#fff', fontWeight: 700}} disabled={fuModal.saving} onClick={saveFollowUp}>
                  {fuModal.saving ? <span className='spinner-border spinner-border-sm' /> : 'שמור מעקב'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {dialing && (
        <div style={{position: 'fixed', bottom: 20, insetInlineStart: 20, zIndex: 1060, background: '#fff', borderRadius: 14, boxShadow: '0 8px 30px rgba(0,0,0,0.18)', padding: '14px 18px', minWidth: 280, maxWidth: 380, borderInlineStart: `5px solid ${['failed', 'no_answer', 'busy'].includes(dialing.state) ? '#e5534b' : dialing.state === 'connected' ? AFF.success : AFF.accent}`}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10}}>
            <div style={{fontWeight: 700, color: AFF.ink}}>
              <i className='bi bi-telephone-outbound me-2' />
              {dialing.name || 'ליד'} <span dir='ltr' style={{fontWeight: 400, color: AFF.muted}}>{dialing.phone}</span>
            </div>
            <button className='btn-close' style={{fontSize: 10}} onClick={() => setDialing(null)} />
          </div>
          <div style={{marginTop: 6, fontSize: 14, color: AFF.ink}}>
            {dialing.state === 'starting' ? 'מתחבר למרכזייה…' : dialing.state === 'ended' ? 'השיחה הסתיימה — הסיכום יופיע בעמודה "שיחה אחרונה" בעוד כמה שניות' : (dialing.error || DIAL_STATE[dialing.state] || dialing.state)}
          </div>
          <div style={{marginTop: 4, fontSize: 12, color: AFF.muted}}>שלוחה {dialing.ext}</div>
        </div>
      )}

      {callsFor && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}} onClick={(e) => { if (e.target === e.currentTarget) setCallsFor(null) }}>
          <div className='modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'>
                  <i className='bi bi-telephone me-2' style={{color: AFF.accent}} />
                  שיחות — {callsFor.row.name || callsFor.row.display_phone}
                </h5>
                <button className='btn-close' onClick={() => setCallsFor(null)} />
              </div>
              <div className='modal-body' style={{paddingTop: 0}}>
                {callsFor.loading ? (
                  <div style={{textAlign: 'center', padding: 30}}><span className='spinner-border' /></div>
                ) : callsFor.error ? (
                  <div className='alert alert-danger'>{callsFor.error}</div>
                ) : !callsFor.data?.calls?.length ? (
                  <div style={{color: AFF.muted, textAlign: 'center', padding: 30}}>אין עדיין שיחות עם הליד הזה.</div>
                ) : callsFor.data.calls.map((c) => {
                  const om = c.ai && CALL_OUTCOME[c.ai.outcome]
                  const det = callDetail[c.id]
                  return (
                    <div key={c.id} style={{border: `1px solid ${AFF.border}`, borderRadius: 12, padding: 14, marginBottom: 12}}>
                      <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 6, fontSize: 13, color: AFF.muted}}>
                        <span>
                          <b style={{color: AFF.ink}}>{moment(c.at).format('DD/MM/YY HH:mm')}</b>
                          {c.agentName ? ` · ${c.agentName}` : ''}{c.ext ? ` (שלוחה ${c.ext})` : ''}
                          {c.recSecs ? ` · ${fmtSecs(c.recSecs)} דק'` : ''}
                          <span dir='ltr' className='ms-2'>{c.phone}</span>
                        </span>
                        {om && <span className={`badge ${om.cls}`} style={{fontWeight: 700}}>{om.label}</span>}
                      </div>
                      {c.ai ? (
                        <>
                          <div style={{marginTop: 8, color: AFF.ink}}>🤖 {c.ai.summary}</div>
                          {c.ai.key_points?.length > 0 && (
                            <ul style={{margin: '8px 0 0', paddingInlineStart: 18, fontSize: 13, color: AFF.ink}}>
                              {c.ai.key_points.map((k, i) => <li key={i}>{k}</li>)}
                            </ul>
                          )}
                          {c.ai.next_step && <div style={{marginTop: 8, fontSize: 13}}><b>הצעד הבא:</b> {c.ai.next_step}</div>}
                          {c.ai.follow_up_time && <div style={{marginTop: 2, fontSize: 13}}><b>לחזור:</b> {c.ai.follow_up_time}</div>}
                          {!callsFor.row.is_manual && (
                            <button className='btn btn-sm btn-light-warning mt-2' onClick={() => openFollowUp(callsFor.row, c.ai)}>
                              <i className='bi bi-calendar-plus me-1' />קבע מעקב לפי השיחה
                            </button>
                          )}
                        </>
                      ) : (
                        <div style={{marginTop: 8, color: AFF.muted, fontSize: 13}}>{c.aiState === 'processing' ? '🤖 מסכם את השיחה…' : 'אין סיכום AI לשיחה זו'}</div>
                      )}
                      {c.note && <div style={{marginTop: 6, fontSize: 13}}><b>הערת הנציג:</b> {c.note}</div>}
                      <div style={{display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap', alignItems: 'center'}}>
                        {c.hasRecording && (
                          <audio controls preload='none' src={pbxRecordingUrl(c.id, callsFor.row._id)} style={{height: 34, maxWidth: '100%'}} />
                        )}
                        <button className='btn btn-sm btn-light' onClick={() => toggleCall(c.id)}>
                          <i className={`bi ${openCallId === c.id ? 'bi-chevron-up' : 'bi-card-text'} me-1`} />
                          {openCallId === c.id ? 'הסתר תמליל' : 'תמליל מלא'}
                        </button>
                      </div>
                      {openCallId === c.id && (
                        <div style={{marginTop: 10, maxHeight: 300, overflow: 'auto', background: '#f8f9fb', borderRadius: 8, padding: 10, fontSize: 13}}>
                          {!det ? <span className='spinner-border spinner-border-sm' /> : !det.transcript?.length ? 'אין תמליל' : det.transcript.map((t, i) => (
                            <div key={i} style={{marginBottom: 4}}><b>{t.who}:</b> {t.text}</div>
                          ))}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {waLead && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'>
                  <i className='bi bi-whatsapp text-success me-2' />
                  וואטסאפ — {waLead.name || waLead.display_phone}
                </h5>
                <button className='btn-close' onClick={() => setWaLead(null)} />
              </div>
              <div className='modal-body'>
                {waStatus !== 'connected' ? (
                  <div style={{textAlign: 'center', padding: 20}}>
                    <div style={{color: AFF.muted, marginBottom: 12}}>הוואטסאפ שלך לא מחובר.</div>
                    <Link to='/affiliate/whatsapp' className='btn btn-sm' style={{background: AFF.accent, color: '#fff'}}>חבר וואטסאפ</Link>
                  </div>
                ) : (
                  <>
                    <div style={{fontSize: 13, color: AFF.muted, marginBottom: 8}}>הודעות מהירות (לחיצה שולחת מיד):</div>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16}}>
                      {templates.length === 0 && adminTemplates.length === 0 ? (
                        <span style={{fontSize: 13, color: AFF.muted}}>אין הודעות מוכנות. אפשר להוסיף בעמוד "וואטסאפ".</span>
                      ) : (
                        <>
                          {/* Admin-defined messages (read-only here, but sendable) */}
                          {adminTemplates.map((t, i) => (
                            <button
                              key={'a' + i}
                              className='btn btn-sm btn-light-primary'
                              disabled={waSending}
                              title={fillName(t.text, waLead)}
                              onClick={() => sendWa(waLead, fillName(t.text, waLead), t.media)}
                            >
                              <i className='bi bi-shield-lock me-1' style={{opacity: 0.7}} />
                              {t.title || 'הודעה'}
                              {(t.media || []).length > 0 && (
                                <span style={{marginInlineStart: 6, opacity: 0.8}}>
                                  <i className='bi bi-paperclip' />
                                  {(t.media || []).length}
                                </span>
                              )}
                            </button>
                          ))}
                          {templates.map((t, i) => (
                            <button
                              key={i}
                              className='btn btn-sm btn-light-success'
                              disabled={waSending}
                              title={fillName(t.text, waLead)}
                              onClick={() => sendWa(waLead, fillName(t.text, waLead), t.media)}
                            >
                              {t.title || 'הודעה'}
                              {(t.media || []).length > 0 && (
                                <span style={{marginInlineStart: 6, opacity: 0.8}}>
                                  <i className='bi bi-paperclip' />
                                  {(t.media || []).length}
                                </span>
                              )}
                            </button>
                          ))}
                        </>
                      )}
                    </div>
                    <div style={{fontSize: 13, color: AFF.muted, marginBottom: 6}}>או הודעה חופשית:</div>
                    <textarea
                      className='form-control'
                      rows={3}
                      value={waMessage}
                      onChange={(e) => setWaMessage(e.target.value)}
                      placeholder='כתוב הודעה…'
                    />
                  </>
                )}
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => setWaLead(null)}>סגור</button>
                {waStatus === 'connected' && (
                  <button className='btn btn-success' disabled={waSending || !waMessage.trim()} onClick={() => sendWa(waLead, waMessage)}>
                    {waSending ? 'שולח…' : 'שלח'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {convertRow && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'>
                  <i className='bi bi-person-check text-success me-2' />
                  המרת ליד ללקוח — {convertRow.name}
                </h5>
                <button className='btn-close' onClick={() => setConvertRow(null)} />
              </div>
              <div className='modal-body'>
                <div style={{fontSize: 13, color: AFF.muted, marginBottom: 14}}>
                  אשר/עדכן את הפרטים. ⚠️ הטלפון מ‑יד2 לרוב וירטואלי — הזן את המספר האמיתי (וואטסאפ) של הלקוח.
                </div>
                <div className='row g-3'>
                  <div className='col-md-6'>
                    <label className='form-label'>שם מלא</label>
                    <input className='form-control' value={convertForm.name} onChange={(e) => setConvertForm({...convertForm, name: e.target.value})} />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label required'>טלפון אמיתי</label>
                    <input className='form-control' dir='ltr' value={convertForm.phone} onChange={(e) => setConvertForm({...convertForm, phone: e.target.value})} placeholder='05X-XXXXXXX' />
                    <div style={{fontSize: 11.5, color: AFF.muted, marginTop: 3}}>טלפון הלקוח — משמש לחיבור הפרופיל וכברירת מחדל לפרסומים.</div>
                    {/* Contact number that appears inside the generated posts — right under the real phone */}
                    <div style={{marginTop: 10, padding: '10px 12px', borderRadius: 10, border: `1px solid ${AFF.border}`}}>
                      <div style={{fontWeight: 600, color: AFF.ink, marginBottom: 6, fontSize: 13}}>מספר ליצירת קשר בפרסומים</div>
                      <label style={{display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: AFF.ink, fontSize: 13}}>
                        <input type='checkbox' className='form-check-input' checked={convertForm.postsUseReal} onChange={(e) => setConvertForm({...convertForm, postsUseReal: e.target.checked})} />
                        השתמש בטלפון האמיתי שהוזן למעלה
                      </label>
                      {!convertForm.postsUseReal && (
                        <input className='form-control mt-2' dir='ltr' value={convertForm.postsPhone} onChange={(e) => setConvertForm({...convertForm, postsPhone: e.target.value})} placeholder='מספר אחר לפרסומים — 05X-XXXXXXX' />
                      )}
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>אימייל (לא חובה)</label>
                    <input className='form-control' dir='ltr' value={convertForm.email} onChange={(e) => setConvertForm({...convertForm, email: e.target.value})} placeholder='ברירת מחדל: לפי הטלפון' />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>שם עסק / סוכנות</label>
                    <input className='form-control' value={convertForm.company_name} onChange={(e) => setConvertForm({...convertForm, company_name: e.target.value})} />
                  </div>
                  <div className='col-12'>
                    <label className='form-label'>רישיון תיווך (לא חובה)</label>
                    <input
                      className='form-control'
                      value={convertForm.licenseText || ''}
                      onChange={(e) => setConvertForm({...convertForm, licenseText: e.target.value})}
                      placeholder='למשל: רישיון תיווך: 12345'
                    />
                    <div style={{fontSize: 11.5, color: AFF.muted, marginTop: 3}}>
                      יתווסף בתחתית כל פוסט מיובא. ניתן לערוך את הטקסט המלא.
                    </div>
                  </div>
                </div>

                <div style={{marginTop: 14, padding: '16px 16px', borderRadius: 12, background: AFF.accentSoft, border: `2px solid ${AFF.accent}`}}>
                  <label style={{display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontWeight: 700, fontSize: 15, color: AFF.ink}}>
                    <input
                      type='checkbox'
                      className='form-check-input'
                      style={{width: 20, height: 20}}
                      checked={convertImport}
                      onChange={(e) => setConvertImport(e.target.checked)}
                    />
                    ייבא את כל נכסי הסוכן מיד2 {convertListingCount != null ? `(${convertListingCount} נכסים)` : ''}
                  </label>
                  <div style={{fontSize: 12.5, color: AFF.muted, marginTop: 6, paddingInlineStart: 30}}>
                    ייווצרו קמפיינים לפי עיר עם פוסטים (כולל סוג הנכס ומספר הקשר). לאחר היצירה תועבר/י לדף הייבוא, והייבוא יתחיל אוטומטית עם סרגל התקדמות.
                  </div>
                  {convertImport && (
                    <label style={{display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: AFF.ink, marginTop: 10, paddingInlineStart: 30}} title='כשמכובה — הפוסטים יובאו ללא שורת המחיר'>
                      <input
                        type='checkbox'
                        className='form-check-input'
                        checked={convertForm.includePrice !== false}
                        onChange={(e) => setConvertForm({...convertForm, includePrice: e.target.checked})}
                      />
                      כלול מחירים בפוסטים
                    </label>
                  )}
                  {convertImport && (
                    <label style={{display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: AFF.ink, marginTop: 8, paddingInlineStart: 30}} title='אם מכובה — מודעות ללא תמונות ייובאו אך לא יפורסמו'>
                      <input
                        type='checkbox'
                        className='form-check-input'
                        checked={convertForm.includeNoImages !== false}
                        onChange={(e) => setConvertForm({...convertForm, includeNoImages: e.target.checked})}
                      />
                      כלול מודעות ללא תמונות
                    </label>
                  )}
                  {/* Live preview of how an imported post will look */}
                  {convertImport && (
                    <div style={{marginTop: 12}}>
                      <div style={{fontSize: 12, color: AFF.muted, fontWeight: 600, marginBottom: 6}}>
                        <i className='bi bi-eye me-1' />תצוגה מקדימה של פוסט:
                      </div>
                      {convertSample ? (
                        <div style={{background: '#fff', border: `1px solid ${AFF.border}`, borderRadius: 10, padding: 12, fontSize: 13, color: AFF.ink, whiteSpace: 'pre-line', direction: 'rtl', maxHeight: 220, overflowY: 'auto'}}>
                          {buildConvertPreview()}
                        </div>
                      ) : (
                        <div style={{fontSize: 12.5, color: AFF.muted}}>טוען דוגמה מנכסי הסוכן…</div>
                      )}
                    </div>
                  )}
                </div>

                <div style={{marginTop: 12, padding: '10px 12px', borderRadius: 10, border: `1px solid ${AFF.border}`}}>
                  <label style={{display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontWeight: 600, color: AFF.ink}}>
                    <input
                      type='checkbox'
                      className='form-check-input'
                      checked={convertForm.sendConnect}
                      onChange={(e) => setConvertForm({...convertForm, sendConnect: e.target.checked})}
                    />
                    שלח קוד QR לחיבור הפרופיל בוואטסאפ לטלפון שהוזן
                  </label>
                  <div style={{fontSize: 11.5, color: AFF.muted, marginTop: 4, paddingInlineStart: 26}}>
                    בכל מקרה ייווצר אוטומטית פרופיל פייסבוק ראשון. ה‑QR נטען ברקע ויישלח ברגע שיהיה מוכן (לא ממתין לייבוא). בטלו אם תרצו לשלוח ידנית מאוחר יותר.
                  </div>
                </div>
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => setConvertRow(null)}>ביטול</button>
                <button className='btn btn-success' disabled={converting || !convertForm.phone.trim()} onClick={doConvert}>
                  {converting ? 'יוצר…' : 'צור לקוח (14 יום ניסיון)'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {meetingFor && (
        <AffiliateMeetingModal
          customer={meetingFor}
          onClose={() => setMeetingFor(null)}
          onBooked={() => setMeetingFor(null)}
        />
      )}

      {/* Edit customer-account details (converted leads) */}
      {custEdit && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'><i className='bi bi-pencil-square text-primary me-2' />עריכת פרטי לקוח</h5>
                <button className='btn-close' onClick={() => setCustEdit(null)} />
              </div>
              <div className='modal-body'>
                <div style={{fontSize: 12.5, color: AFF.muted, marginBottom: 12}}>השינויים מעדכנים את חשבון הלקוח עצמו. עדכון הטלפון מעדכן גם את שם המשתמש להתחברות.</div>
                <div className='row g-3'>
                  <div className='col-md-6'>
                    <label className='form-label'>שם פרטי</label>
                    <input className='form-control' value={custEdit.form.first_name} onChange={(e) => setCustEdit({...custEdit, form: {...custEdit.form, first_name: e.target.value}})} />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>שם משפחה</label>
                    <input className='form-control' value={custEdit.form.last_name} onChange={(e) => setCustEdit({...custEdit, form: {...custEdit.form, last_name: e.target.value}})} />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>טלפון</label>
                    <input className='form-control' dir='ltr' value={custEdit.form.phone} onChange={(e) => setCustEdit({...custEdit, form: {...custEdit.form, phone: e.target.value}})} placeholder='05X-XXXXXXX' />
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label'>אימייל</label>
                    <input className='form-control' dir='ltr' value={custEdit.form.email} onChange={(e) => setCustEdit({...custEdit, form: {...custEdit.form, email: e.target.value}})} />
                  </div>
                  <div className='col-12'>
                    <label className='form-label'>שם עסק / סוכנות</label>
                    <input className='form-control' value={custEdit.form.company_name} onChange={(e) => setCustEdit({...custEdit, form: {...custEdit.form, company_name: e.target.value}})} />
                  </div>
                </div>
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => setCustEdit(null)}>ביטול</button>
                <button className='btn btn-primary' disabled={custSaving} onClick={saveCustEdit}>{custSaving ? 'שומר…' : 'שמור'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FB profile connection modal (converted leads) */}
      {welcomeFor && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}} onClick={() => setWelcomeFor(null)}>
          <div className='modal-dialog modal-dialog-centered' onClick={(e) => e.stopPropagation()}>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0 pb-0'>
                <h5 className='modal-title fw-bold'>שליחת הודעת ברוכים הבאים</h5>
                <button className='btn-close' onClick={() => setWelcomeFor(null)} />
              </div>
              <div className='modal-body'>
                <p className='text-muted mb-2'>
                  באיזה אמצעי לשלוח ל{welcomeFor.name || welcomeFor.customer?.email || 'לקוח'}?
                </p>
                {welcomeFor.customer?.welcome_sent && (
                  <div className='alert alert-warning py-2 small mb-3'>
                    הודעה כבר נשלחה{welcomeFor.customer.welcome_sent_at ? ' · ' + moment(welcomeFor.customer.welcome_sent_at).format('DD/MM/YY HH:mm') : ''} — בחירת אמצעי תשלח שוב.
                  </div>
                )}
                {/* Message text — copy manually if needed */}
                <label className='form-label small text-muted mb-1'>תוכן ההודעה</label>
                <textarea className='form-control form-control-sm mb-1' dir='rtl' rows={5} readOnly value={welcomePreview?.message || 'טוען…'} />
                <button
                  className='btn btn-sm btn-light w-100 mb-3'
                  disabled={!welcomePreview}
                  onClick={() => { if (welcomePreview) { navigator.clipboard?.writeText(welcomePreview.message); setWelcomeCopied(true); setTimeout(() => setWelcomeCopied(false), 1500) } }}
                >
                  <i className={`bi ${welcomeCopied ? 'bi-check2' : 'bi-clipboard'} me-1`} />{welcomeCopied ? 'הועתק' : 'העתק טקסט'}
                </button>
                <div className='d-flex gap-2'>
                  <button className='btn btn-success flex-fill d-flex flex-column align-items-center py-3' onClick={() => sendWelcome(welcomeFor, 'whatsapp')}>
                    <i className='bi bi-whatsapp fs-3 mb-1' />
                    <span className='small'>וואטסאפ</span>
                  </button>
                  <button className='btn btn-primary flex-fill d-flex flex-column align-items-center py-3' onClick={() => sendWelcome(welcomeFor, 'sms')}>
                    <i className='bi bi-chat-dots fs-3 mb-1' />
                    <span className='small'>SMS</span>
                  </button>
                  <button className='btn btn-outline-success flex-fill d-flex flex-column align-items-center py-3' disabled={!welcomePreview} title='פתח וואטסאפ עם ההודעה — שליחה ידנית' onClick={() => welcomeViaWaWeb(welcomeFor)}>
                    <i className='bi bi-whatsapp fs-3 mb-1' />
                    <span className='small'>וואטסאפ Web</span>
                  </button>
                </div>
                <div className='text-muted small mt-3'>
                  וואטסאפ = מהוואטסאפ המחובר שלך · SMS = ממערכת FBZipper · וואטסאפ Web = פתיחה ידנית בדפדפן/אפליקציה
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {profCustomer && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered modal-lg'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'>
                  <i className='bi bi-facebook text-primary me-2' />
                  פרופילי פייסבוק — {profCustomer.name || profCustomer.customer?.email}
                </h5>
                <button className='btn-close' onClick={closeProfiles} />
              </div>
              <div className='modal-body'>
                {profLoading ? (
                  <div style={{textAlign: 'center', padding: 30}}><span className='spinner-border text-primary' /></div>
                ) : profiles.length === 0 ? (
                  <div style={{textAlign: 'center', color: AFF.muted, padding: 30}}>אין פרופילים בחשבון הלקוח עדיין.</div>
                ) : (
                  <>
                  {profiles.filter((p) => !p.connected).length > 1 && (
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: AFF.accentSoft, borderRadius: 10, padding: '10px 14px', marginBottom: 14}}>
                      <span style={{fontSize: 13, color: AFF.ink}}>{profiles.filter((p) => !p.connected).length} פרופילים לא מחוברים · מלא טלפונים ושלח לכולם בבת אחת</span>
                      <button className='btn btn-sm' style={{background: AFF.accent, color: '#fff', fontWeight: 600}} disabled={bulkSending} onClick={bulkSendLinks}>
                        <i className='bi bi-send me-1' /> {bulkSending ? 'שולח…' : 'שלח קישור לכולם'}
                      </button>
                    </div>
                  )}
                  {profiles.map((p) => (
                    <div key={p._id} style={{border: `1px solid ${AFF.border}`, borderRadius: 12, padding: 16, marginBottom: 12}}>
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div style={{fontWeight: 600, color: AFF.ink}}>{p.name}</div>
                        {p.connected ? (
                          <span className='badge badge-light-success'><i className='bi bi-check-circle me-1' /> מחובר{p.active ? ' · פעיל' : ''}</span>
                        ) : p.credentials_submitted_at ? (
                          // The client did their part. The login itself is finished by a
                          // rep, so this sits between "לא מחובר" and "מחובר" — without it
                          // the row looks untouched for as long as the rep takes.
                          <span className='badge badge-light-warning' title={`הלקוח שלח שם משתמש וסיסמה ב-${moment(p.credentials_submitted_at).format('DD/MM/YY HH:mm')}`}>
                            <i className='bi bi-key me-1' /> הלקוח הזין פרטים · {moment(p.credentials_submitted_at).fromNow()}
                          </span>
                        ) : (
                          <span className='badge badge-light-danger'>לא מחובר</span>
                        )}
                      </div>
                      {/* The way into the profile's live browser, always available on an
                          unconnected profile — before the client has typed anything (the
                          affiliate can just do the login for them) and after (Facebook
                          often parks it on a 2FA prompt or a checkpoint that nobody
                          clears, so somebody has to go look). Only the wording changes;
                          the link is the same and is already minted with the list.
                          It goes through openLiveLogin rather than a bare href because
                          that also makes sure a browser is actually RUNNING for this
                          profile — a preview of a profile with no bot shows nothing. */}
                      {!p.connected && (
                        <div style={{marginTop: 10, background: p.credentials_submitted_at ? '#fff8e6' : AFF.accentSoft, border: `1px solid ${p.credentials_submitted_at ? '#f5d98a' : AFF.border}`, borderRadius: 10, padding: '10px 12px'}}>
                          <div style={{fontSize: 13, color: AFF.ink, fontWeight: 600, marginBottom: 6}}>
                            {p.credentials_submitted_at
                              ? `🔑 הלקוח הזין שם משתמש וסיסמה · ${moment(p.credentials_submitted_at).format('DD/MM/YY HH:mm')} (${moment(p.credentials_submitted_at).fromNow()})`
                              : '🕐 הלקוח עדיין לא הזין שם משתמש וסיסמה'}
                          </div>
                          <div style={{fontSize: 12.5, color: AFF.muted, marginBottom: 8}}>
                            {p.credentials_submitted_at
                              ? 'היכנסו לדפדפן החי של הפרופיל וודאו שההתחברות הושלמה — ייתכן שממתין שם אימות דו-שלבי.'
                              : 'אפשר להיכנס לדפדפן החי של הפרופיל ולהתחבר עבור הלקוח כבר עכשיו.'}
                          </div>
                          <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center'}}>
                            <button
                              className='btn btn-sm'
                              style={{background: AFF.accent, color: '#fff', fontSize: 12, whiteSpace: 'nowrap'}}
                              disabled={previewBusy === p._id}
                              title='פותח את הדפדפן החי של הפרופיל — אפשר להתחבר עבור הלקוח ולעבור אימות דו-שלבי במקום'
                              onClick={() => openLiveLogin(p)}
                            >
                              {previewBusy === p._id
                                ? <><span className='spinner-border spinner-border-sm me-1' /> פותח…</>
                                : <><i className='bi bi-display me-1' />פתח את הדפדפן של הפרופיל</>}
                            </button>
                            {p.preview_url && (
                              <button className='btn btn-sm btn-light' style={{fontSize: 12}} onClick={() => copyUrl(p.preview_url)}>
                                <i className={`bi ${copied ? 'bi-check2' : 'bi-link-45deg'} me-1`} />{copied ? 'הועתק' : 'העתק קישור'}
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                      {/* A connected profile can still get logged out or hit a
                          checkpoint, so the live browser stays one click away
                          here too (the not-connected block has its own copy,
                          next to the login-screen button where it belongs). */}
                      {p.connected && p.preview_url && (
                        <a className='btn btn-sm btn-light mt-2' style={{fontSize: 12}}
                          title='פתח את הדפדפן החי של הפרופיל' href={p.preview_url} target='_blank' rel='noreferrer'>
                          🔗 פתח את הדפדפן של הפרופיל
                        </a>
                      )}
                      {!p.connected && (
                        <div style={{marginTop: 12}}>
                          {connecting && connecting.profileId === p._id ? (
                            connecting.status === 'ready' ? (
                              <div style={{textAlign: 'center'}}>
                                {/* Post-scan device-verification: once the customer scans, FB
                                    shows a 2-digit number they must tap on their phone to finish.
                                    Shown the moment the bot captures it, above the QR. */}
                                {authApproval && authApproval.profileId === p._id && authApproval.code && (
                                  <div style={{background: '#e7f7ed', border: '1px solid #9bd9b2', borderRadius: 12, padding: '12px 14px', marginBottom: 12}}>
                                    <div style={{fontSize: 13, color: AFF.ink, fontWeight: 600, marginBottom: 6}}>הלקוח סרק — לאישור ההתחברות יש להקיש בטלפון על המספר:</div>
                                    <div style={{fontSize: 34, fontWeight: 800, letterSpacing: 4, color: '#1b7a3d', lineHeight: 1}}>{authApproval.code}</div>
                                    <div style={{fontSize: 12, color: AFF.muted, marginTop: 6}}>בטלפון מופיעים כמה מספרים — יש להקיש על {authApproval.code}</div>
                                  </div>
                                )}
                                <div style={{background: '#fff', display: 'inline-block', padding: 12, borderRadius: 12, border: `1px solid ${AFF.border}`}}>
                                  <QRCode value={connecting.url} size={180} />
                                </div>
                                {/* FB pairing code (3-3-4) — the customer can type this instead of scanning. */}
                                {connecting.code && (
                                  <div style={{marginTop: 10}}>
                                    <div style={{fontSize: 12, color: AFF.muted, marginBottom: 2}}>קוד לחיבור ידני (במקום סריקה):</div>
                                    <div style={{display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center'}}>
                                      <span style={{fontSize: 22, fontWeight: 800, letterSpacing: 2, color: AFF.ink}}>{connecting.code}</span>
                                      <button className='btn btn-sm btn-light' style={{fontSize: 12, whiteSpace: 'nowrap'}} title='העתק קוד' onClick={() => copyUrl(connecting.code)}>
                                        <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} me-1`} />{copied ? 'הועתק' : 'העתק קוד'}
                                      </button>
                                    </div>
                                  </div>
                                )}
                                <div style={{fontSize: 13, color: AFF.muted, marginTop: 10}}>הלקוח סורק את הברקוד מהטלפון שמחובר לאפליקציית פייסבוק, או פותח את הקישור:</div>
                                {/* Full message text — copy manually / send anywhere */}
                                <textarea className='form-control form-control-sm mt-2' dir='rtl' rows={4} readOnly
                                  value={connectReadyMsg(connecting.url, connecting.code)} />
                                <div style={{display: 'flex', gap: 8, marginTop: 8}}>
                                  <button className='btn btn-sm flex-fill' style={{background: AFF.accent, color: '#fff', whiteSpace: 'nowrap'}} onClick={() => copyUrl(connectReadyMsg(connecting.url, connecting.code))}>
                                    <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} me-1`} />{copied ? 'הועתק' : 'העתק טקסט'}
                                  </button>
                                  <button className='btn btn-sm btn-light flex-fill' style={{whiteSpace: 'nowrap'}} onClick={() => copyUrl(connecting.url)}>
                                    <i className='bi bi-link-45deg me-1' />העתק קישור בלבד
                                  </button>
                                </div>
                                <div style={{display: 'flex', gap: 8, marginTop: 8, alignItems: 'center'}}>
                                  <input className='form-control form-control-sm' dir='ltr' style={{maxWidth: 170}} placeholder='טלפון לשליחה' value={profPhones[p._id] || ''} onChange={(e) => setProfPhones((m) => ({...m, [p._id]: e.target.value}))} />
                                  <button className='btn btn-sm btn-light-success' style={{whiteSpace: 'nowrap'}} disabled={!(profPhones[p._id] || '').trim()} title='שלח קישור התחברות בוואטסאפ' onClick={() => sendLink(p)}>
                                    <i className='bi bi-whatsapp me-1' /> וואטסאפ
                                  </button>
                                  <button className='btn btn-sm btn-light-info' style={{whiteSpace: 'nowrap'}} disabled={!(profPhones[p._id] || '').trim()} title='שלח קישור ב‑SMS (מ‑FBZipper)' onClick={() => sendSmsLink(p)}>
                                    <i className='bi bi-chat-dots me-1' /> SMS
                                  </button>
                                  <a className='btn btn-sm btn-outline-success' style={{whiteSpace: 'nowrap'}} title='פתח וואטסאפ עם הקישור — שליחה ידנית' target='_blank' rel='noreferrer'
                                    href={waWebUrl(profPhones[p._id] || '', connectReadyMsg(connecting.url, connecting.code))}>
                                    <i className='bi bi-whatsapp me-1' /> Web
                                  </a>
                                  {linkSentFor[p._id] && <span className='badge badge-light-success'>נשלח ✓</span>}
                                </div>
                                {/* Alternative to the QR: share the username/password connect link. */}
                                {p.password_url && (
                                  <div style={{marginTop: 10, paddingTop: 10, borderTop: `1px dashed ${AFF.border}`, fontSize: 12.5}}>
                                    <span style={{color: AFF.muted}}>מעדיפים חיבור עם שם משתמש וסיסמה? </span>
                                    <button className='btn btn-sm btn-light' style={{fontSize: 12}} onClick={() => copyUrl(p.password_url!)}>
                                      <i className={`bi ${copied ? 'bi-check2' : 'bi-link-45deg'} me-1`} />העתק קישור סיסמה
                                    </button>
                                    <a className='btn btn-sm btn-outline-success ms-1' style={{fontSize: 12}} target='_blank' rel='noreferrer'
                                      href={waWebUrl(profPhones[p._id] || '', connectMsg(p.password_url!))}>
                                      <i className='bi bi-whatsapp me-1' />וואטסאפ
                                    </a>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div style={{color: AFF.muted, fontSize: 13}}>
                                <div><span className='spinner-border spinner-border-sm me-2' />מכין ברקוד התחברות… (עד דקה)</div>
                                {/* Barcode didn't load? After 60s, allow deleting the stuck profile + recreating it. */}
                                <div style={{marginTop: 10, display: 'flex', alignItems: 'center', gap: 8}}>
                                  <button
                                    className='btn btn-sm btn-light-danger'
                                    style={{fontSize: 12}}
                                    disabled={resetRemaining > 0 || resetting}
                                    title={resetRemaining > 0 ? 'ניתן לאיפוס רק אם הברקוד לא נטען תוך דקה' : 'מחק את הפרופיל וצור ברקוד חדש'}
                                    onClick={() => resetBarcode(p._id)}
                                  >
                                    {resetting ? <span className='spinner-border spinner-border-sm me-1' /> : <i className='bi bi-trash me-1' />}
                                    מחק וצור ברקוד חדש
                                  </button>
                                  {resetRemaining > 0 && (
                                    <span style={{fontSize: 12, color: AFF.muted}}>ניתן בעוד {fmtCountdown(resetRemaining)}</span>
                                  )}
                                </div>
                              </div>
                            )
                          ) : (
                            <div>
                              {/* Full message text — copy manually / send anywhere */}
                              <textarea className='form-control form-control-sm mb-1' dir='rtl' rows={4} readOnly
                                value={profileLoginMsg(p)} />
                              <div style={{display: 'flex', gap: 8, marginBottom: 8}}>
                                <button className='btn btn-sm flex-fill' style={{background: AFF.accent, color: '#fff', whiteSpace: 'nowrap'}} onClick={() => copyUrl(profileLoginMsg(p))}>
                                  <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} me-1`} />{copied ? 'הועתק' : 'העתק טקסט'}
                                </button>
                                <button className='btn btn-sm btn-light flex-fill' style={{whiteSpace: 'nowrap'}} onClick={() => copyUrl(profileLoginUrl(p))}>
                                  <i className='bi bi-link-45deg me-1' />העתק קישור בלבד
                                </button>
                              </div>
                              <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                                <input className='form-control form-control-sm' dir='ltr' style={{maxWidth: 170}} placeholder='טלפון וואטסאפ' value={profPhones[p._id] || ''} onChange={(e) => setProfPhones((m) => ({...m, [p._id]: e.target.value}))} />
                                <button className='btn btn-sm btn-light-success' style={{whiteSpace: 'nowrap'}} disabled={!(profPhones[p._id] || '').trim()} onClick={() => sendLink(p)}>
                                  <i className='bi bi-whatsapp me-1' /> שלח קישור
                                </button>
                                <button className='btn btn-sm btn-light-info' style={{whiteSpace: 'nowrap'}} disabled={!(profPhones[p._id] || '').trim()} title='שלח קישור ב‑SMS (מ‑FBZipper)' onClick={() => sendSmsLink(p)}>
                                  <i className='bi bi-chat-dots me-1' /> SMS
                                </button>
                                <a className='btn btn-sm btn-outline-success' style={{whiteSpace: 'nowrap'}} title='פתח וואטסאפ עם ההודעה — שליחה ידנית' target='_blank' rel='noreferrer'
                                  href={waWebUrl(profPhones[p._id] || '', profileLoginMsg(p))}>
                                  <i className='bi bi-whatsapp me-1' /> Web
                                </a>
                                {linkSentFor[p._id] && <span className='badge badge-light-success'>נשלח ✓</span>}
                              </div>
                              {/* The live browser lives in the panel above this block —
                                  it's there for every unconnected profile — so this stays
                                  what it was: the CLIENT-facing login screen. */}
                              <button className='btn btn-sm btn-light me-0 mt-2' style={{fontSize: 12}} onClick={() => connectProfile(p)}>
                                {p.login_method === 'password' ? (
                                  <><i className='bi bi-box-arrow-up-right me-1' /> או פתח את מסך ההתחברות עכשיו</>
                                ) : (
                                  <><i className='bi bi-qr-code me-1' /> או פתח ברקוד עכשיו (פותח דפדפן)</>
                                )}
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                  </>
                )}
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => openProfiles(profCustomer)}>רענן סטטוס</button>
                <button className='btn btn-light' onClick={closeProfiles}>סגור</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {poolModal && (
        <div className='modal show d-block' tabIndex={-1} style={{background: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered modal-lg'>
            <div className='modal-content' style={{borderRadius: 16, border: 'none'}}>
              <div className='modal-header border-0'>
                <h5 className='modal-title fw-bold'><i className='bi bi-search me-2' />חיפוש סוכן במאגר וצירוף כליד</h5>
                <button className='btn-close' onClick={() => setPoolModal(false)} />
              </div>
              <div className='modal-body'>
                <div style={{display: 'flex', gap: 8, marginBottom: 14}}>
                  <input
                    className='form-control'
                    autoFocus
                    value={poolQuery}
                    onChange={(e) => setPoolQuery(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && searchPool()}
                    placeholder='חפש לפי שם / טלפון / סוכנות…'
                  />
                  <button className='btn btn-primary' onClick={searchPool} disabled={poolSearching || poolQuery.trim().length < 2} style={{whiteSpace: 'nowrap', fontWeight: 700}}>
                    {poolSearching ? 'מחפש…' : 'חפש'}
                  </button>
                </div>

                {poolSearched && !poolSearching && poolResults.length === 0 && (
                  <div style={{textAlign: 'center', color: AFF.muted, padding: '24px 0'}}>לא נמצאו סוכנים תואמים במאגר.</div>
                )}

                {poolResults.length > 0 && (
                  <div style={{maxHeight: 420, overflowY: 'auto', border: `1px solid ${AFF.border}`, borderRadius: 12}}>
                    {poolResults.map((a, i) => (
                      <div key={a.phone || i} style={{display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', borderBottom: i < poolResults.length - 1 ? `1px solid ${AFF.border}` : 'none'}}>
                        <div style={{flex: 1, minWidth: 0}}>
                          <div style={{fontWeight: 700, color: AFF.text || '#181c32'}}>{a.name || '(ללא שם)'}</div>
                          <div style={{fontSize: 12.5, color: AFF.muted}} dir='ltr'>
                            {a.phone}{a.agency_name ? ` · ${a.agency_name}` : ''}{a.listings_count != null ? ` · ${a.listings_count} נכסים` : ''}
                          </div>
                        </div>
                        {a.lead_state === 'mine' ? (
                          <span className='badge badge-light-success' style={{fontWeight: 700}}>ברשימה שלי ✓</span>
                        ) : a.lead_state === 'taken' ? (
                          <span className='badge badge-light-dark' title='נתפס על ידי שותף אחר'>תפוס</span>
                        ) : (
                          <button className='btn btn-sm btn-primary' onClick={() => claimFromPool(a)} disabled={claiming === a.phone} style={{fontWeight: 700, whiteSpace: 'nowrap'}}>
                            {claiming === a.phone ? 'מצרף…' : 'צרף ללידים שלי'}
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className='modal-footer border-0'>
                <button className='btn btn-light' onClick={() => setPoolModal(false)}>סגור</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </AffiliateShell>
  )
}

export default AffiliateLeadsMgrWrapper
